import React, { useEffect, useMemo, useRef, useState } from "react";
import Drawer from "../SideDrawer/SideDrawer";
import Button from "../Button/Button";
import CloseIcon from "../../assets/svg/close-icon";
import ArrowIcon from "../../assets/svg/arrow-icon";
import InboxIcon from "../../assets/svg/inbox-icon";
import CalendarIcon from "../../assets/svg/calendar-icon";
import CampaignsIcon from "../../assets/svg/campaigns-icon";
import CommunicationModeFilter from "./CommonFilters/CommunicationModeFilter";
import CircularArrowBackIcon from "../../assets/svg/circular-arrow-back-icon";
import DurationFilter from "./CommonFilters/DurationFilter";
import SelectCampaignFilter from "./CommonFilters/SelectCampaignFilter";
import {
  // clearCommunicationsCampaign,
  clearCommunicationsMode,
  clearCommunicationsDuration,
  selectCommunicationsDuration,
  clearAllCommunicationsFilters,
  enableClearAllCommunicationsFilters,
  clearCampaignCommunicationsMode,
  clearCampaignCommunicationsCampaign,
  clearCampaignCommunicationsStatus,
  clearCampaignCommunicationsOutcome,
  clearCampaignsCategory,
  selectCampaignsFilters,
  clearCampaignsUser,
  clearCampaignsUseCase,
  clearCampaignsBranch,
  clearCampaignsStartedOn,
  clearCampaignsCreatedOn,
  clearAllCampaignsFilters,
  clearAllCampaignCommunicationsFilters,
  enableClearAllCampaignCommunicationsFilters,
  enableClearAllCampaignsFilters,
  selectCampaignTemplatesFilters,
  clearCampaignTemplatesCreatedOn,
  clearCampaignTemplatesUser,
  clearAllCampaignTemplatesFilters,
  enableClearAllCampaignTemplatesFilters,
  clearCampaignLogsCampaign,
  selectCampaignLogsFilters,
  clearAllCampaignLogsFilters,
  enableClearAllCampaignLogsFilters,
  clearCampaignExecutionLogsMode,
  clearCampaignExecutionLogsDateRange,
  selectCampaignExecutionLogsFilters,
  clearAllCampaignExecutionLogsFilters,
  enableClearAllCampaignExecutionLogsFilters,
  clearCampaignExecutionLogsStatus,
  selectCampaignCommunicationsFilters,
  selectCommunicationsFilters,
  FilterState,
  selectFilterState,
  clearCrmLeadsSourceCountry,
  clearCrmLeadsDestinationCountry,
  clearCrmLeadsDestinationCity,
  clearCrmLeadsUniversity,
  enableClearAllCrmLeadsFilters,
  enableClearAllAnalyticsFilters,
  clearAnalyticsDuration,
  clearAnalyticsCommunicationType,
  clearAnalyticsModality,
  clearAllAnalyticsFilters,
  enableClearAllBillingFilters,
  clearBillingDuration,
  clearBillingCommunicationType,
  clearAllBillingFilters,
  clearAllCrmLeadsFilters,
  clearCrmLeadsAssignedAgents,
  clearCrmLeadsTags,
  clearCrmLeadsRoomType,
  clearCrmLeadsAcademicYear,
  clearCrmLeadsLeadStage,
  clearCrmLeadsDealStage,
  clearCrmLeadsDealPropertyName,
  clearCrmLeadsDealRoomType,
  clearCrmLeadsDealAcademicYear,
  clearCrmLeadsDealAvailabilityTitle,
  clearCrmLeadsDealCity,
  clearCrmLeadsDealAssignee,
  clearCrmLeadsDealRoomNumber,
  clearCrmLeadsLeadType,
  setCrmLeadsViewing,
  setCrmLeadsRepeatLead,
  setCrmLeadsActiveFollowUps,
  setCrmLeadsNotUpdated30Days,
  clearCrmLeadsLastActivity,
  clearCrmLeadsBedCount,
  clearCrmLeadsPropertyCount,
  clearCrmLeadsDuration,
  clearCrmLeadsCommunicationType,
  clearPlaygroundDuration,
  clearPlaygroundChangesMadeOn,
  clearPlaygroundLogsCreatedOn,
  selectPlaygroundLogsFilters,
  clearAllPlaygroundLogsFilters,
  enableClearAllPlaygroundLogsFilters,
  clearCommunicationAnalyticsMode,
  clearCommunicationAnalyticsDuration,
  clearAllCommunicationAnalyticsFilters,
  enableClearAllCommunicationAnalyticsFilters,
  selectCommunicationsBudget,
  clearCommunicationsBudget,
  clearCommunicationsDestinationCountry,
  clearCommunicationsCity,
  clearCommunicationsUniversity,
  clearCommunicationsTags,
  clearCommunicationsRoomType,
  clearCommunicationsProperty,
  clearCommunicationsUtmSources,
  clearCommunicationsUtmMedium,
  clearCommunicationsAttributionChannel,
  clearCommunicationsStandardMedium,
  clearCommunicationsStandardSource,
  clearCommunicationsDeviceType,
  clearCommunicationsLease,
  clearCommunicationsSourceCountry,
  clearCommunicationsAssignedAgents,
  clearCommunicationsLeadType,
  setCommunicationsViewing,
  setCommunicationsRepeatLead,
  clearCampaignsStatus,
  clearCommunicationsBotVersion,
  clearCommunicationsVisitorPresence,
  clearCrmLeadsProperty,
  clearCrmLeadsUtmSources,
  clearCrmLeadsUtmMedium,
  clearCrmLeadsAttributionChannel,
  clearCrmLeadsStandardMedium,
  clearCrmLeadsStandardSource,
  clearCrmLeadsDeviceType,
  clearAllCrmInboxFilters,
  enableClearAllCrmInboxFilters,
  clearCrmInboxAssignedAgents,
  clearCrmInboxDuration,
  selectViewingsFilters,
  clearViewingsFilters,
  enableClearAllViewingsFilters,
  clearViewingsScheduledOn,
  clearViewingsCreatedOn,
  clearViewingsProperty,
  clearViewingsAttendeeResponse,
} from "../../redux/slices/filterSlice";
import { setCurrentPage } from "../../redux/slices/allCampaignSlice";
import { useDispatch, useSelector } from "react-redux";
import CampaignCommStatusFilter from "./CampaignFilters/CampaignCommStatusFilter";
import OutcomeIcon from "../../assets/svg/outcome-icon";
import CampaignOutcomeFilter from "./CampaignFilters/CampaignOutcomeFilter";
import CampaignCategoryFilter from "./CampaignFilters/CampaignCategoryFilter";
import CategoryIcon from "../../assets/svg/category-icon";
import StatusIcon from "../../assets/svg/status-icon";
import UserIcon from "../../assets/svg/user-icon";
import CampaignUserFilter from "./CampaignFilters/CampaignUserFilter";
import CampaignUseCaseFilter from "./CampaignFilters/CampaignUseCaseFilter";
import UseCaseIcon from "../../assets/svg/use-case";
import CampaignBranchFilter from "./CampaignFilters/CampaignBranchFilter";
import PropertyManagementIcon from "../../assets/svg/property-management-icon";
import CampaignStartsOnFilter from "./CampaignFilters/CampaignStartsOnFilter";
import { format } from "date-fns";
import CampaignCreatedOnFilter from "./CampaignFilters/CampaignCreatedOnFilter";
import ExecutionLogsStatusFilter from "./CampaignFilters/ExecutionLogsStatusFilter";
import CountryFilter from "./CrmFilters/CountryFilter";
import LocationIcon from "../../assets/svg/location-icon";
import CityFilter from "./CrmFilters/CityFilter";
import UniversityFilter from "./CrmFilters/UniversityFilter";
import ProfileTwoUser from "../../assets/svg/v1/profile-two-user";
import AgentFilter from "./CommonFilters/AgentFilter";
import TagsIcon from "../../assets/svg/tags-icon";
import TagsFilter from "./CrmFilters/TagsFilter";
import RoomTypeIcon from "../../assets/svg/room-type-icon";
import RoomTypeFilter from "./CrmFilters/RoomTypeFilter";
import AcademicYearFilter from "./CrmFilters/AcademicYearFilter";
import LeadStageFilter from "./CrmFilters/LeadStageFilter";
import DealMultiSelectFilter from "./CrmFilters/DealMultiSelectFilter";
import DealRoomNumberFilter from "./CrmFilters/DealRoomNumberFilter";
import LeadStageIcon from "../../assets/svg/lead-stage-icon";
import UniversityIcon from "../../assets/svg/university-icon";
import BedCountFilter from "./CrmFilters/BedCountFilter";
import LastActivityFilter from "./CrmFilters/LastActivityFilter";
import PropertyCountFilter from "./CrmFilters/PropertyCountFilter";
import FlaggedIcon from "../../assets/svg/flagged-icon";
import ViewingsIcon from "../../assets/svg/viewings-icon";
import RepeatLeadIcon from "../../assets/svg/repeat-lead-icon";
import LeadTypeFilter from "./CommonFilters/LeadTypeFilter";
import ChatbotVersionFilter from "./CommonFilters/ChatbotVersionFilter";
import VisitorPresenceFilter from "./CommonFilters/VisitorPresenceFilter";
import ToggleSwitch from "../ToggleSwitch/ToggleSwitch";
import CommunicationTypeFilter from "./CommonFilters/CommunicationTypeFilter";
import AnalyticsDurationFilter from "./AnalyticsFilters/AnalyticsDurationFilter";
import AnalyticsCommunicationTypeFilter from "./AnalyticsFilters/AnalyticsCommunicationTypeFilter";
import BillingDurationFilter from "./BillingFilters/BillingDurationFilter";
import BillingCommunicationTypeFilter from "./BillingFilters/BillingCommunicationTypeFilter";
import InboundIcon from "../../assets/svg/inbound-icon";
import OutboundIcon from "../../assets/svg/outbound-icon";
import NetworkIcon from "../../assets/svg/network-icon";
import VerbachatIcon from "../../assets/svg/verbachat-icon";
import UserSingleIcon from "../../assets/svg/user-single-icon";
import SyncIcon from "../../assets/svg/sync-icon";
import PlaygroundEnvFilter from "./PlaygroundLogsFilters/PlaygroundEnvFilter";
import LogsCreatedOnFilter from "./PlaygroundLogsFilters/LogsCreatedOnFilter";
import { WORKFLO_NAME } from "../../utils/constants/globalConstants";
import { getDefaultDurationValue } from "../../utils/constants/durationDefaults";
import BudgetFilter from "./CommonFilters/BudgetFilter";
import PropertyFilter from "./CommonFilters/PropertyFilter";
import HomeIcon from "../../assets/svg/home-icon";
import UtmSourcesFilter from "./CommonFilters/UtmSourcesFilter";
import UtmMediumFilter from "./CommonFilters/UtmMediumFilter";
import AttributionFilter from "./CommonFilters/AttributionFilter";
import GlobeOneIcon from "../../assets/svg/globe-one-icon";
import UtmMediumIcon from "../../assets/svg/utm-medium-icon";
import DeviceTypeIcon from "../../assets/svg/device-type-icon";
import TowerIcon from "../../assets/svg/TowerIcon";
import LeaseFilter from "./CommonFilters/LeaseFilter";
import { Tooltip } from "../Tooltip/Tooltip";
import { truncateItemsWithCount } from "../../utils/functions/formatters";
import CampaignStatusFilter from "./CampaignFilters/CampaignStatusFilter";
import { RootState } from "../../redux/store";
import { FILTER_LABELS, getDynamicFilterLabels } from "./utils/constants";
import { useFilterTracking } from "../../utils/amplitude/hooks/useFilterTracking";
import { getViewingLabels } from "../../utils/constants/mappings";
import {
  clearAllPmsPropertiesFilters,
  clearAllPmsLogsFilters,
  clearPmsDestinationCountry,
  clearPmsCity,
  clearPmsUniversity,
  clearPmsBudget,
  clearPmsRoomType,
  clearPmsLogsDuration,
  selectPmsPropertiesFilters,
  selectPmsLogsFilters,
  enableClearAllPmsPropertiesFilters as enableClearAllPmsPropertiesFiltersSelector,
  enableClearAllPmsLogsFilters as enableClearAllPmsLogsFiltersSelector,
} from "../../redux/slices/pmsFilterSlice";
import CommunicationAllIcon from "../../assets/svg/communication-all-icon";
import { getDateTimeByFormat } from "../../redux/slices/dateTimeFormatSlice";
import TaskAssigneeFilter from "./TasksFilters/TaskAssigneeFilter";
import {
  selectTasksFilters,
  setTasksDueToday,
  setTasksOverdue,
  setTasksUpcoming,
  setTasksCompleted,
  clearTasksAssigneeIds,
  clearTasksPropertyIds,
  clearTasksCityIds,
  clearTasksCountryIds,
  clearAllTasksFilters,
  enableClearAllTasksFilters,
} from "../../redux/slices/tasksFilterSlice";
import TasksIcon from "../../assets/svg/tasks-icon";
import SortByIcon from "../../assets/svg/sort-by-icon";
import SortFilter from "./ViewingsFilters/SortFilter";
import ViewingsDateRangeFilter from "./ViewingsFilters/ViewingsDateRangeFilter";
import ViewingsAttendeeResponseFilter from "./ViewingsFilters/ViewingsAttendeeResponseFilter";

interface FilterItemProps {
  label: string;
  description: string;
  value: string | boolean;
  disabled?: boolean;
  onClick: () => void;
  icon: React.ReactNode | null;
  iconClass?: string;
  showClearButton?: boolean;
  clearFilter?: () => void;
  showToggleSwitch?: boolean;
  handleToggle?: () => void;
  itemClassName?: string;
}

interface FilterDetailViewProps {
  filter: {
    label: string;
    description: string;
    value: string | boolean;
    icon: React.ReactNode | null;
    filterComponent?: React.ReactNode | null;
    clearFilter?: () => void;
    showClearButton?: boolean;
  };
  onBack: () => void;
  onClose: () => void;
}

const FilterDetailView: React.FC<FilterDetailViewProps> = ({
  filter,
  onBack,
  onClose,
}) => {
  const handleClearFilter = () => {
    filter.clearFilter?.();
    onBack();
  };

  return (
    <div className="flex flex-col h-full">
      <div className="flex flex-col gap-4 px-3 py-3 border-b border-border-gray dark:border-border-gray-dk">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            {" "}
            <button
              onClick={onBack}
              className="flex items-center justify-center w-6 h-6 rounded-full hover:bg-hover-gray dark:hover:bg-hover-gray-dk transition-colors"
            >
              <CircularArrowBackIcon className="w-5 h-5 text-verba-indigo dark:text-verba-indigo-dk" />
            </button>
            <h2 className="text-verba-indigo dark:text-verba-indigo-dk text-base font-semibold">
              {filter.label}
            </h2>
          </div>
          <div className="flex items-center gap-4.5">
            {filter?.showClearButton && (
              <Button
                innerText="Clear"
                onClick={handleClearFilter}
                buttonContainerClass="py-1 px-3 border border-border-gray dark:border-border-gray-dk rounded-sm"
                innerTextClass="text-md font-medium whitespace-nowrap text-verba-indigo dark:text-verba-indigo-dk"
              />
            )}
            <button
              className={`w-[16px] h-[16px] bg-tag-gray dark:bg-tag-gray-dk rounded-full flex flex-col items-center justify-center transition-transform duration-200 hover:scale-110`}
              aria-label="Close modal"
              onClick={onClose}
            >
              <CloseIcon className="w-[6px] h-[6px] text-verba-indigo dark:text-verba-indigo-dk" />
            </button>
          </div>
        </div>
      </div>
      <div className="flex-1 overflow-y-auto">
        <div className="flex flex-col">
          {filter?.filterComponent && filter?.filterComponent}
        </div>
      </div>
    </div>
  );
};

const FilterItem: React.FC<FilterItemProps> = ({
  label,
  description,
  value,
  icon,
  onClick,
  disabled,
  showClearButton,
  clearFilter,
  showToggleSwitch,
  handleToggle,
  itemClassName = "",
}) => {
  const handleClearFilter = (event: React.MouseEvent<HTMLElement>) => {
    event?.preventDefault();
    event?.stopPropagation();
    clearFilter?.();
  };

  const displayValue = useMemo(() => {
    return value ? truncateItemsWithCount(value as string) : value;
  }, [value]);

  const fontSize = useSelector(
    (state: RootState) => state.fontSettings.fontSize
  );

  const showCrossButtonTransition =
    fontSize === 4 || fontSize === 3 ? false : true;

  const content = (
    <div
      className={`flex items-center justify-between w-full gap-2 ${
        disabled ? "cursor-not-allowed" : ""
      }`}
    >
      <div className="flex items-center gap-2 min-w-0 flex-1">
        <div className="flex items-center justify-center shrink-0 w-[18px] h-[18px] min-w-[18px] min-h-[18px]">
          {icon}
        </div>
        <div className="flex flex-col items-start min-w-0">
          {label && (
            <span className="text-verba-indigo dark:text-verba-indigo-dk text-md break-words text-left">
              {label}
            </span>
          )}

          <span className="text-xs text-dark-gray dark:text-dark-gray-dk break-words text-left">
            {description}
          </span>
        </div>
      </div>
      <div className="flex items-center justify-end gap-2 shrink-0">
        {value && !showToggleSwitch && (
          <div className="group flex items-center px-1.5 py-0.5 rounded-[4px] bg-verba-blue-light-card-bg dark:bg-verba-blue-light-card-bg-dk whitespace-nowrap">
            <span className="text-xs text-verba-blue dark:text-verba-blue-dk font-medium">
              {displayValue}
            </span>
            <span
              className={`overflow-hidden w-0 shrink-0 ${showCrossButtonTransition ? "transition-all duration-200" : ""} ${
                showClearButton ? "group-hover:w-3 group-hover:ml-1" : "w-0"
              }`}
            >
              <Tooltip content="Clear Filter" side="top" delayDuration={0}>
                <span
                  className="cursor-pointer bg-verba-red-alert dark:bg-verba-red-alert-dk rounded-full flex items-center justify-center w-3 h-3"
                  onClick={handleClearFilter}
                >
                  <CloseIcon className="w-[5px] h-[5px] text-pure-white dark:text-pure-white-dk shrink-0" />
                </span>
              </Tooltip>
            </span>
          </div>
        )}
        {showToggleSwitch ? (
          <ToggleSwitch
            isChecked={value as boolean}
            handleToggle={handleToggle as () => void}
          />
        ) : (
          <ArrowIcon className="w-2.5 h-2.5 text-verba-indigo dark:text-verba-indigo-dk shrink-0" />
        )}
      </div>
    </div>
  );

  const wrapperClassName = `w-full flex flex-col gap-1 px-3 py-3.5 border-b border-border-gray dark:border-border-gray-dk ${
    disabled ? "opacity-60 " : ""
  }${itemClassName ? ` ${itemClassName}` : ""}`;

  // Avoid <button> inside <button> when ToggleSwitch is rendered.
  return showToggleSwitch ? (
    <div className={wrapperClassName} aria-disabled={disabled}>
      {content}
    </div>
  ) : (
    <button
      type="button"
      onClick={onClick}
      className={wrapperClassName}
      disabled={disabled}
    >
      {content}
    </button>
  );
};

const SectionDivider = ({ label }: { label: string }) => (
  <div className="px-4 pb-1">
    <span className="text-xs font-semibold uppercase text-dark-gray dark:text-dark-gray-dk leading-none">
      {label}
    </span>
  </div>
);

const Filters = ({
  openDrawer,
  handleDrawerClose,
  size,
  filterType,
  modalities = [],
  campaignId,
}: {
  openDrawer: boolean;
  handleDrawerClose: () => void;
  size: string;
  filterType: string;
  modalities?: string[];
  campaignId?: string;
}) => {
  const filterState = useSelector(selectFilterState);
  const pmsPropertiesFilters = useSelector(selectPmsPropertiesFilters);
  const pmsLogsFilters = useSelector(selectPmsLogsFilters);

  const client = useSelector((state: RootState) => state?.auth?.client);

  const communicationMode = useSelector(
    filterType === "campaign-communications"
      ? (state: { filter: FilterState }) =>
          selectCampaignCommunicationsFilters(state)?.mode
      : filterType === "campaign-execution-logs"
        ? (state: { filter: FilterState }) =>
            selectCampaignExecutionLogsFilters(state)?.mode
        : filterType === "communication-analytics"
          ? (state: { filter: FilterState }) =>
              state.filter.communicationAnalytics.mode
          : (state: { filter: FilterState }) =>
              selectCommunicationsFilters(state)?.mode
  );

  const duration = useSelector(
    filterType === "crm"
      ? (state: { filter: FilterState }) => state.filter.crmLeads.duration
      : filterType === "analytics"
        ? (state: { filter: FilterState }) => state.filter.analytics.duration
        : filterType === "billing"
          ? (state: { filter: FilterState }) => state.filter.billing.duration
          : filterType === "playground"
            ? (state: { filter: FilterState }) =>
                state.filter.playground.duration
            : filterType === "communication-analytics"
              ? (state: { filter: FilterState }) =>
                  state.filter.communicationAnalytics.duration
              : (state: { filter: FilterState }) =>
                  selectCommunicationsDuration(state)
  );

  const campaign = useSelector(
    filterType === "campaign-communications"
      ? (state: { filter: FilterState }) =>
          selectCampaignCommunicationsFilters(state)?.campaign
      : (state: { filter: FilterState }) =>
          selectCommunicationsFilters(state)?.campaign
  );

  const campaignStatus = useSelector(
    (state: { filter: FilterState }) =>
      selectCampaignCommunicationsFilters(state)?.status
  );
  const campaignOutcome = useSelector(
    (state: { filter: FilterState }) =>
      selectCampaignCommunicationsFilters(state)?.outcome
  );
  const campaignFilters = useSelector(selectCampaignsFilters);
  const campaignTemplatesFilters = useSelector(selectCampaignTemplatesFilters);
  const campaignLogsFilters = useSelector(selectCampaignLogsFilters);
  const campaignExecutionLogsFilters = useSelector(
    selectCampaignExecutionLogsFilters
  );
  const playgroundLogsFilters = useSelector(selectPlaygroundLogsFilters);
  const playgroundChangesMadeOn = playgroundLogsFilters?.changesMadeOn;
  const playgroundCreatedOn = playgroundLogsFilters?.createdOn;
  const sourceCountry = filterState?.crmLeads?.sourceCountry;
  const destinationCountry = filterState?.crmLeads?.destinationCountry;
  const destinationCity = filterState?.crmLeads?.destinationCity;
  const university =
    filterType === "crm"
      ? filterState?.crmLeads?.university
      : filterState?.communications?.university;
  const assignedAgents = filterState?.crmLeads?.assignedAgents;
  const tags =
    filterType === "crm"
      ? filterState?.crmLeads?.tags
      : filterState?.communications?.tags;
  const roomType =
    filterType === "crm"
      ? filterState?.crmLeads?.roomType
      : filterState?.communications?.roomType;
  const academicYear = filterState?.crmLeads?.academicYear;
  const leadStage = filterState?.crmLeads?.leadStage;
  const dealStage = filterState?.crmLeads?.dealStage;
  const dealPropertyName = filterState?.crmLeads?.dealPropertyName;
  const dealRoomType = filterState?.crmLeads?.dealRoomType;
  const dealAcademicYear = filterState?.crmLeads?.dealAcademicYear;
  const dealAvailabilityTitle = filterState?.crmLeads?.dealAvailabilityTitle;
  const dealCity = filterState?.crmLeads?.dealCity;
  const dealAssignee = filterState?.crmLeads?.dealAssignee;
  const dealRoomNumber = filterState?.crmLeads?.dealRoomNumber;
  const city = filterState?.communications?.city;
  const leadType = filterState?.crmLeads?.leadType;
  const viewing = filterState?.crmLeads?.viewing;
  const repeatLead = filterState?.crmLeads?.repeatLead;
  const bedCount = filterState?.crmLeads?.bedCount;
  const propertyCount = filterState?.crmLeads?.propertyCount;
  const activeFollowUps = filterState?.crmLeads?.activeFollowUps;
  const leadsNotUpdated30Days = filterState?.crmLeads?.leadsNotUpdated30Days;
  const lastActivity = filterState?.crmLeads?.lastActivity;
  const communicationType =
    filterType === "analytics"
      ? filterState?.analytics?.communicationType
      : filterType === "billing"
        ? filterState?.billing?.communicationType
        : filterState?.crmLeads?.communicationType;
  const analyticsModality = filterState?.analytics?.modality;
  const budget = useSelector(selectCommunicationsBudget);
  const destinationCountryCommunications =
    filterState?.communications?.destinationCountry;
  const sourceCountryCommunications =
    filterState?.communications?.sourceCountry;
  const property =
    filterType === "crm"
      ? filterState?.crmLeads?.property
      : filterState?.communications?.property;
  const utmSources = filterState?.communications?.utmSources;
  const utmMedium = filterState?.communications?.utmMedium;
  const attributionChannel = filterState?.communications?.attributionChannel;
  const standardMedium = filterState?.communications?.standardMedium;
  const standardSource = filterState?.communications?.standardSource;
  const deviceType = filterState?.communications?.deviceType;
  const crmUtmSources = filterState?.crmLeads?.utmSources;
  const crmUtmMedium = filterState?.crmLeads?.utmMedium;
  const crmAttributionChannel = filterState?.crmLeads?.attributionChannel;
  const crmStandardMedium = filterState?.crmLeads?.standardMedium;
  const crmStandardSource = filterState?.crmLeads?.standardSource;
  const crmDeviceType = filterState?.crmLeads?.deviceType;
  const lease = filterState?.communications?.lease;
  const leaseDisplayValue = lease?.displayValue;
  const communicationsAssignedAgents =
    filterState?.communications?.assignedAgents;
  const communicationsLeadType = filterState?.communications?.leadType;
  const communicationsViewing = filterState?.communications?.viewing;
  const communicationsRepeatLead = filterState?.communications?.repeatLead;
  const botVersion = filterState?.communications?.botVersion;
  const visitorPresence = filterState?.communications?.visitorPresence;

  const tasksFilters = useSelector(selectTasksFilters);
  const crmInboxFilters = useSelector(
    (state: RootState) => state.filter.crmInbox
  );
  const viewingsFilters = useSelector(selectViewingsFilters);

  const isVerbafloClient = client?.client_code === "verbaflo";
  const viewingLabels = getViewingLabels(client?.region, isVerbafloClient);

  type FilterItem = {
    label: string;
    description: string;
    value: string | boolean;
    trackingValue?: string;
    icon: React.ReactNode;
    filterComponent?: React.ReactNode;
    clearFilter?: () => void;
    showClearButton?: boolean;
    disabled?: boolean;
    showToggleSwitch?: boolean;
    handleToggle?: () => void;
  };

  const [activeFilter, setActiveFilter] = useState<FilterItem | null>(null);
  const dispatch = useDispatch();
  const { trackFilterApplied, trackFilterCleared, trackAllFiltersCleared } =
    useFilterTracking(filterType);

  const prevActiveFilterRef = useRef<FilterItem | null>(null);

  const handleGoBack = () => {
    setActiveFilter(null);
  };

  const dynamicFilterLabels = getDynamicFilterLabels(client?.region);

  // A duration sitting on the tenant's default isn't a filter the user applied, so it gets no
  // clear chip. Resolved once here rather than re-typed per screen (they used to drift).
  const defaultDurationValue = getDefaultDurationValue();

  const filterMappings: Record<string, FilterItem[]> = {
    communication: [
      {
        label: FILTER_LABELS.communication.modeOfCommunication.label,
        description:
          FILTER_LABELS.communication.modeOfCommunication.description,
        value: communicationMode?.displayValue as string,
        icon: (
          <InboxIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: (
          <CommunicationModeFilter
            onClose={handleGoBack}
            modalities={modalities}
          />
        ),
        clearFilter: () => {
          dispatch(clearCommunicationsMode());
        },
        showClearButton: communicationMode.value !== "all",
      },
      {
        label: FILTER_LABELS.communication.duration.label,
        description: FILTER_LABELS.communication.duration.description,
        value: duration?.displayValue as string,
        icon: (
          <CalendarIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: <DurationFilter onClose={handleGoBack} />,
        clearFilter: () => {
          dispatch(clearCommunicationsDuration());
        },
        showClearButton: duration.value !== defaultDurationValue,
      },
      ...(communicationMode.value === "widget"
        ? [
            {
              label: FILTER_LABELS.communication.chatbotVersion.label,
              description:
                FILTER_LABELS.communication.chatbotVersion.description,
              value: (botVersion?.displayValue as string[])?.length
                ? truncateItemsWithCount(
                    (botVersion.displayValue as string[]).join(", ")
                  )
                : "",
              icon: (
                <VerbachatIcon className="w-[18px] h-[18px] text-verba-blue dark:text-verba-blue-dk" />
              ),
              filterComponent: (
                <ChatbotVersionFilter onClose={handleGoBack} />
              ),
              showClearButton: (botVersion?.value as string[])?.length > 0,
              clearFilter: () => {
                dispatch(clearCommunicationsBotVersion());
              },
            },
            {
              label: FILTER_LABELS.communication.visitorPresence.label,
              description:
                FILTER_LABELS.communication.visitorPresence.description,
              value: (visitorPresence?.displayValue as string) || "",
              icon: (
                <UserSingleIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
              ),
              filterComponent: (
                <VisitorPresenceFilter onClose={handleGoBack} />
              ),
              showClearButton: !!visitorPresence?.value,
              clearFilter: () => {
                dispatch(clearCommunicationsVisitorPresence());
              },
            },
          ]
        : []),
      // {
      //   label: `${WORKFLO_NAME.singular}`,
      //   description: `Select the ${WORKFLO_NAME.singular}`,
      //   value: campaign?.displayValue as string,
      //   icon: (
      //     <CampaignsIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
      //   ),
      //   filterComponent: <SelectCampaignFilter onClose={handleDrawerClose} />,
      //   clearFilter: () => {
      //     dispatch(clearCommunicationsCampaign());
      //   },
      //   showClearButton: campaign.value !== "",
      // },
      {
        label: FILTER_LABELS.communication.sourceCountry.label,
        description: FILTER_LABELS.communication.sourceCountry.description,
        value:
          sourceCountryCommunications?.displayValue
            ?.slice(0, 1)
            ?.toString()
            ?.split(",")
            ?.join(", ") +
          (sourceCountryCommunications?.displayValue?.length > 1
            ? ", + " + (sourceCountryCommunications?.displayValue?.length - 1)
            : ""),
        trackingValue: (
          sourceCountryCommunications?.displayValue as string[]
        )?.join(", "),
        icon: (
          <NetworkIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: (
          <CountryFilter
            onClose={handleGoBack}
            isCommunicationSourceCountry={true}
            isMultiSelect={true}
          />
        ),
        showClearButton: sourceCountryCommunications.value.length > 0,
        clearFilter: () => {
          dispatch(clearCommunicationsSourceCountry());
        },
      },
      {
        label: FILTER_LABELS.communication.destinationCountry.label,
        description: FILTER_LABELS.communication.destinationCountry.description,
        value:
          destinationCountryCommunications?.displayValue
            ?.slice(0, 1)
            ?.toString()
            ?.split(",")
            ?.join(", ") +
          (destinationCountryCommunications?.displayValue?.length > 1
            ? ", + " +
              (destinationCountryCommunications?.displayValue?.length - 1)
            : ""),
        trackingValue: (
          destinationCountryCommunications?.displayValue as string[]
        )?.join(", "),
        icon: (
          <NetworkIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: (
          <CountryFilter
            onClose={handleGoBack}
            isCommunicationDestCountry={true}
            isMultiSelect={true}
          />
        ),
        showClearButton: destinationCountryCommunications.value.length > 0,
        clearFilter: () => {
          dispatch(clearCommunicationsDestinationCountry());
          dispatch(clearCommunicationsCity());
          dispatch(clearCommunicationsUniversity());
        },
      },
      {
        label: FILTER_LABELS.communication.destinationCity.label,
        description: FILTER_LABELS.communication.destinationCity.description,
        value:
          city?.displayValue?.slice(0, 1)?.toString()?.split(",")?.join(", ") +
          (city?.displayValue?.length > 1
            ? ", + " + (city?.displayValue?.length - 1)
            : ""),
        trackingValue: (city?.displayValue as string[])?.join(", "),
        icon: (
          <LocationIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: (
          <CityFilter
            onClose={handleGoBack}
            isCommunication={true}
            isMultiSelect={true}
          />
        ),
        showClearButton: Array.isArray(city.value) && city.value.length > 0,
        clearFilter: () => {
          dispatch(clearCommunicationsCity());
          dispatch(clearCommunicationsUniversity());
        },
      },
      {
        label: FILTER_LABELS.communication.destinationUniversity.label,
        description:
          FILTER_LABELS.communication.destinationUniversity.description,
        value: university?.displayValue as string,
        icon: (
          <UniversityIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: (
          <UniversityFilter onClose={handleGoBack} isCommunication={true} />
        ),
        showClearButton: university.value !== "",
        clearFilter: () => {
          dispatch(clearCommunicationsUniversity());
        },
      },
      {
        label: FILTER_LABELS.communication.tags.label,
        description: FILTER_LABELS.communication.tags.description,
        value: tags?.displayValue?.join(", "),
        icon: (
          <TagsIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: (
          <TagsFilter onClose={handleGoBack} isCommunication={true} />
        ),
        showClearButton: tags?.value.length > 0,
        clearFilter: () => {
          dispatch(clearCommunicationsTags());
        },
      },
      {
        label: FILTER_LABELS.communication.roomType.label,
        description: FILTER_LABELS.communication.roomType.description,
        value:
          roomType?.displayValue
            ?.slice(0, 2)
            ?.toString()
            ?.split(",")
            ?.join(", ") +
          (roomType?.displayValue?.length > 2
            ? ", + " + (roomType?.displayValue?.length - 2)
            : ""),
        trackingValue: roomType?.displayValue?.join(", "),
        icon: (
          <RoomTypeIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: (
          <RoomTypeFilter onClose={handleGoBack} isCommunication={true} />
        ),
        showClearButton: roomType?.value.length > 0,
        clearFilter: () => {
          dispatch(clearCommunicationsRoomType());
        },
      },
      {
        label: dynamicFilterLabels.communication.budget.label,
        description: FILTER_LABELS.communication.budget.description,
        value:
          budget?.displayValue
            ?.slice(0, 1)
            ?.toString()
            ?.split(",")
            ?.join(", ") +
          (budget?.displayValue?.length > 1
            ? ", + " + (budget?.displayValue?.length - 1)
            : ""),
        trackingValue: budget?.displayValue?.join(", "),
        icon: dynamicFilterLabels.communication.budget.icon,
        filterComponent: <BudgetFilter onClose={handleGoBack} />,
        showClearButton: budget?.value?.length > 0,
        clearFilter: () => {
          dispatch(clearCommunicationsBudget());
        },
      },
      {
        label: FILTER_LABELS.communication.property.label,
        description: FILTER_LABELS.communication.property.description,
        value:
          property?.displayValue
            ?.slice(0, 1)
            ?.toString()
            ?.split(",")
            ?.join(", ") +
          (property?.displayValue?.length > 1
            ? ", + " + (property?.displayValue?.length - 1)
            : ""),
        trackingValue: property?.displayValue?.join(", "),
        icon: (
          <HomeIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: <PropertyFilter onClose={handleGoBack} />,
        showClearButton: property?.value?.length > 0,
        clearFilter: () => {
          dispatch(clearCommunicationsProperty());
        },
      },
      {
        label: FILTER_LABELS.communication.utmSources.label,
        description: FILTER_LABELS.communication.utmSources.description,
        value:
          utmSources?.displayValue
            ?.slice(0, 1)
            ?.toString()
            ?.split(",")
            ?.join(", ") +
          (utmSources?.displayValue?.length > 1
            ? ", + " + (utmSources?.displayValue?.length - 1)
            : ""),
        trackingValue: utmSources?.displayValue?.join(", "),
        icon: (
          <NetworkIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: <UtmSourcesFilter onClose={handleGoBack} />,
        showClearButton: utmSources?.value?.length > 0,
        clearFilter: () => {
          dispatch(clearCommunicationsUtmSources());
        },
      },
      {
        label: FILTER_LABELS.communication.utmMedium.label,
        description: FILTER_LABELS.communication.utmMedium.description,
        value:
          utmMedium?.displayValue
            ?.slice(0, 1)
            ?.toString()
            ?.split(",")
            ?.join(", ") +
          (utmMedium?.displayValue?.length > 1
            ? ", + " + (utmMedium?.displayValue?.length - 1)
            : ""),
        trackingValue: utmMedium?.displayValue?.join(", "),
        icon: (
          <TowerIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: <UtmMediumFilter onClose={handleGoBack} />,
        showClearButton: utmMedium?.value?.length > 0,
        clearFilter: () => {
          dispatch(clearCommunicationsUtmMedium());
        },
      },
      {
        label: FILTER_LABELS.communication.attributionChannel.label,
        description: FILTER_LABELS.communication.attributionChannel.description,
        value:
          attributionChannel?.displayValue
            ?.slice(0, 1)
            ?.toString()
            ?.split(",")
            ?.join(", ") +
          (attributionChannel?.displayValue?.length > 1
            ? ", + " + (attributionChannel?.displayValue?.length - 1)
            : ""),
        trackingValue: attributionChannel?.displayValue?.join(", "),
        icon: (
          <GlobeOneIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: (
          <AttributionFilter field="attribution_channel" onClose={handleGoBack} />
        ),
        showClearButton: attributionChannel?.value?.length > 0,
        clearFilter: () => {
          dispatch(clearCommunicationsAttributionChannel());
        },
      },
      {
        label: FILTER_LABELS.communication.standardMedium.label,
        description: FILTER_LABELS.communication.standardMedium.description,
        value:
          standardMedium?.displayValue
            ?.slice(0, 1)
            ?.toString()
            ?.split(",")
            ?.join(", ") +
          (standardMedium?.displayValue?.length > 1
            ? ", + " + (standardMedium?.displayValue?.length - 1)
            : ""),
        trackingValue: standardMedium?.displayValue?.join(", "),
        icon: (
          <UtmMediumIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: (
          <AttributionFilter field="standard_medium" onClose={handleGoBack} />
        ),
        showClearButton: standardMedium?.value?.length > 0,
        clearFilter: () => {
          dispatch(clearCommunicationsStandardMedium());
        },
      },
      {
        label: FILTER_LABELS.communication.standardSource.label,
        description: FILTER_LABELS.communication.standardSource.description,
        value:
          standardSource?.displayValue
            ?.slice(0, 1)
            ?.toString()
            ?.split(",")
            ?.join(", ") +
          (standardSource?.displayValue?.length > 1
            ? ", + " + (standardSource?.displayValue?.length - 1)
            : ""),
        trackingValue: standardSource?.displayValue?.join(", "),
        icon: (
          <NetworkIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: (
          <AttributionFilter field="standard_source" onClose={handleGoBack} />
        ),
        showClearButton: standardSource?.value?.length > 0,
        clearFilter: () => {
          dispatch(clearCommunicationsStandardSource());
        },
      },
      {
        label: FILTER_LABELS.communication.deviceType.label,
        description: FILTER_LABELS.communication.deviceType.description,
        value:
          deviceType?.displayValue
            ?.slice(0, 1)
            ?.toString()
            ?.split(",")
            ?.join(", ") +
          (deviceType?.displayValue?.length > 1
            ? ", + " + (deviceType?.displayValue?.length - 1)
            : ""),
        trackingValue: deviceType?.displayValue?.join(", "),
        icon: (
          <DeviceTypeIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: (
          <AttributionFilter field="device_type" onClose={handleGoBack} />
        ),
        showClearButton: deviceType?.value?.length > 0,
        clearFilter: () => {
          dispatch(clearCommunicationsDeviceType());
        },
      },

      {
        label: FILTER_LABELS.communication.leaseDuration.label,
        description: FILTER_LABELS.communication.leaseDuration.description,
        value:
          leaseDisplayValue?.slice(0, 1)?.toString()?.split(",")?.join(", ") +
          (leaseDisplayValue?.length > 1
            ? ", + " + (leaseDisplayValue?.length - 1)
            : ""),
        trackingValue: leaseDisplayValue?.join(", "),
        icon: (
          <CalendarIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: <LeaseFilter onClose={handleGoBack} />,
        showClearButton: lease?.value?.length > 0,
        clearFilter: () => {
          dispatch(clearCommunicationsLease());
        },
      },
      {
        label: FILTER_LABELS.communication.assignedAgents.label,
        description: FILTER_LABELS.communication.assignedAgents.description,
        value:
          communicationsAssignedAgents?.displayValue
            ?.slice(0, 2)
            ?.toString()
            ?.split(",")
            ?.join(", ") +
          (communicationsAssignedAgents?.displayValue?.length > 2
            ? ", + " + (communicationsAssignedAgents?.displayValue?.length - 2)
            : ""),
        trackingValue: communicationsAssignedAgents?.displayValue?.join(", "),
        icon: (
          <ProfileTwoUser className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: (
          <AgentFilter onClose={handleGoBack} isCommunication={true} />
        ),
        showClearButton: communicationsAssignedAgents?.value.length > 0,
        clearFilter: () => {
          dispatch(clearCommunicationsAssignedAgents());
        },
      },
      {
        label: FILTER_LABELS.communication.leadType.label,
        description: FILTER_LABELS.communication.leadType.description,
        value: communicationsLeadType?.displayValue as string,
        icon: (
          <ProfileTwoUser className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: (
          <LeadTypeFilter onClose={handleGoBack} isCommunication={true} />
        ),
        showClearButton: communicationsLeadType?.value !== "",
        clearFilter: () => {
          dispatch(clearCommunicationsLeadType());
        },
      },
      {
        label: FILTER_LABELS.communication.viewings.label,
        description: FILTER_LABELS.communication.viewings.description,
        value: communicationsViewing,
        icon: (
          <ViewingsIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        showToggleSwitch: true,
        handleToggle: () => {
          dispatch(setCommunicationsViewing(!communicationsViewing));
        },
      },
      {
        label: FILTER_LABELS.communication.excludeRepeatLeads.label,
        description: FILTER_LABELS.communication.excludeRepeatLeads.description,
        value: communicationsRepeatLead,
        icon: (
          <RepeatLeadIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        showToggleSwitch: true,
        handleToggle: () => {
          dispatch(setCommunicationsRepeatLead(!communicationsRepeatLead));
          trackFilterApplied(
            FILTER_LABELS.communication.excludeRepeatLeads.label,
            !communicationsRepeatLead ? "enabled" : "disabled"
          );
        },
      },
    ],
    "campaign-communications": [
      {
        label: FILTER_LABELS.campaignCommunications.modeOfCommunication.label,
        description:
          FILTER_LABELS.campaignCommunications.modeOfCommunication.description,
        value: communicationMode?.displayValue as string,
        icon: (
          <InboxIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: (
          <CommunicationModeFilter
            onClose={handleGoBack}
            modalities={modalities}
            isCampaignCommunication={true}
          />
        ),
        clearFilter: () => {
          dispatch(clearCampaignCommunicationsMode());
        },
        showClearButton: communicationMode.value !== "all",
      },
      {
        label: `${WORKFLO_NAME.singular}`,
        description: `Select the ${WORKFLO_NAME.singular}`,
        value: campaign?.displayValue as string,
        icon: (
          <CampaignsIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: (
          <SelectCampaignFilter
            onClose={handleGoBack}
            isCampaignCommunication={true}
          />
        ),
        clearFilter: () => {
          dispatch(clearCampaignCommunicationsCampaign());
        },
        showClearButton: false,
      },
      {
        label: FILTER_LABELS.campaignCommunications.status.label,
        description: FILTER_LABELS.campaignCommunications.status.description,
        icon: (
          <InboxIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        value: campaignStatus.displayValue as string,
        filterComponent: (
          <CampaignCommStatusFilter
            onClose={handleGoBack}
            communicationMode={
              communicationMode as { value: string; displayValue: string }
            }
          />
        ),
        clearFilter: () => {
          dispatch(clearCampaignCommunicationsStatus());
        },
        showClearButton: campaignStatus.displayValue !== "Select status",
        disabled: communicationMode.value === "all",
      },
      {
        label: FILTER_LABELS.campaignCommunications.outcome.label,
        description: FILTER_LABELS.campaignCommunications.outcome.description,
        value: campaignOutcome?.displayValue as string,
        icon: (
          <OutcomeIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: (
          <CampaignOutcomeFilter
            onClose={handleGoBack}
            campaignId={campaignId || ""}
          />
        ),
        clearFilter: () => {
          dispatch(clearCampaignCommunicationsOutcome());
        },
        showClearButton: campaignOutcome.value !== "",
      },
    ],
    campaigns: [
      {
        label: FILTER_LABELS.campaigns.categories.label,
        description: FILTER_LABELS.campaigns.categories.description,
        value: campaignFilters.category.displayValue as string,
        icon: (
          <CategoryIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: <CampaignCategoryFilter onClose={handleGoBack} />,
        clearFilter: () => {
          dispatch(clearCampaignsCategory());
        },
        showClearButton: campaignFilters.category.value !== "",
      },
      {
        label: FILTER_LABELS.campaigns.useCase.label,
        description: FILTER_LABELS.campaigns.useCase.description,
        value: campaignFilters.useCase.displayValue as string,
        icon: (
          <UseCaseIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: <CampaignUseCaseFilter onClose={handleGoBack} />,
        clearFilter: () => {
          dispatch(clearCampaignsUseCase());
        },
        showClearButton: campaignFilters.useCase.value !== "",
      },
      {
        label: FILTER_LABELS.campaigns.branch.label,
        description: FILTER_LABELS.campaigns.branch.description,
        value: campaignFilters.branch.displayValue as string,
        icon: (
          <PropertyManagementIcon className="w-[16px] h-[16px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: <CampaignBranchFilter onClose={handleGoBack} />,
        clearFilter: () => {
          dispatch(clearCampaignsBranch());
        },
        showClearButton: campaignFilters.branch.value !== "",
      },
      {
        label: FILTER_LABELS.campaigns.createdBy.label,
        description: FILTER_LABELS.campaigns.createdBy.description,
        value: campaignFilters.user.displayValue as string,
        icon: (
          <UserIcon className="w-[16px] h-[16px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: <CampaignUserFilter onClose={handleGoBack} />,
        clearFilter: () => {
          dispatch(clearCampaignsUser());
        },
        showClearButton: campaignFilters.user.value !== "",
      },
      {
        label: FILTER_LABELS.campaigns.status.label,
        description: FILTER_LABELS.campaigns.status.description,
        value:
          campaignFilters?.status?.displayValue
            ?.slice(0, 2)
            ?.toString()
            ?.split(",")
            ?.join(", ") +
          (campaignFilters?.status?.displayValue?.length > 2
            ? ", + " + (campaignFilters?.status?.displayValue?.length - 2)
            : ""),
        trackingValue: (
          campaignFilters?.status?.displayValue as string[]
        )?.join(", "),
        icon: (
          <StatusIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: <CampaignStatusFilter onClose={handleGoBack} />,
        clearFilter: () => {
          dispatch(clearCampaignsStatus());
        },
        showClearButton: campaignFilters.status.value !== "",
      },
      {
        label: FILTER_LABELS.campaigns.startsOnDate.label,
        description: FILTER_LABELS.campaigns.startsOnDate.description,
        value:
          campaignFilters?.startedOn?.displayValue?.from &&
          campaignFilters?.startedOn?.displayValue?.to
            ? format(
                new Date(campaignFilters.startedOn.displayValue.from),
                "dd/MM/yyyy"
              ) +
              " - " +
              format(
                new Date(campaignFilters.startedOn.displayValue.to),
                "dd/MM/yyyy"
              )
            : "",
        icon: (
          <CalendarIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: <CampaignStartsOnFilter onClose={handleGoBack} />,
        clearFilter: () => {
          dispatch(clearCampaignsStartedOn());
        },
        showClearButton:
          campaignFilters.startedOn.value.from !== "" ||
          campaignFilters.startedOn.value.to !== "",
      },
      {
        label: FILTER_LABELS.campaigns.createdOnDate.label,
        description: FILTER_LABELS.campaigns.createdOnDate.description,
        value:
          campaignFilters?.createdOn?.displayValue?.from &&
          campaignFilters?.createdOn?.displayValue?.to
            ? format(
                new Date(campaignFilters.createdOn.displayValue.from),
                "dd/MM/yyyy"
              ) +
              " - " +
              format(
                new Date(campaignFilters.createdOn.displayValue.to),
                "dd/MM/yyyy"
              )
            : "",
        icon: (
          <CalendarIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: (
          <CampaignCreatedOnFilter onClose={handleDrawerClose} />
        ),
        clearFilter: () => {
          dispatch(clearCampaignsCreatedOn());
        },
        showClearButton:
          campaignFilters.createdOn.value.from !== "" ||
          campaignFilters.createdOn.value.to !== "",
      },
    ],
    "campaign-templates": [
      // {
      //   label: "Created By",
      //   description: "Select user",
      //   value: campaignTemplatesFilters.user.displayValue as string,
      //   icon: (
      //     <UserIcon className="w-[16px] h-[16px] text-verba-indigo dark:text-verba-indigo-dk" />
      //   ),
      //   filterComponent: (
      //     <CampaignUserFilter
      //       onClose={handleDrawerClose}
      //       campaignTemplates={true}
      //     />
      //   ),
      //   clearFilter: () => {
      //     dispatch(clearCampaignTemplatesUser());
      //   },
      //   showClearButton: campaignTemplatesFilters.user.value !== "",
      // },
      {
        label: FILTER_LABELS.campaignTemplates.createdOnDate.label,
        description: FILTER_LABELS.campaignTemplates.createdOnDate.description,
        value:
          campaignTemplatesFilters?.createdOn?.displayValue?.from &&
          campaignTemplatesFilters?.createdOn?.displayValue?.to
            ? format(
                new Date(campaignTemplatesFilters.createdOn.displayValue.from),
                "MM/dd/yyyy"
              ) +
              " - " +
              format(
                new Date(campaignTemplatesFilters.createdOn.displayValue.to),
                "MM/dd/yyyy"
              )
            : "",
        icon: (
          <CalendarIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: (
          <CampaignCreatedOnFilter
            onClose={handleDrawerClose}
            campaignTemplates={true}
          />
        ),
        clearFilter: () => {
          dispatch(clearCampaignTemplatesCreatedOn());
        },
        showClearButton:
          campaignTemplatesFilters.createdOn.value.from !== "" ||
          campaignTemplatesFilters.createdOn.value.to !== "",
      },
    ],
    "campaign-logs": [
      {
        label: `${WORKFLO_NAME.singular}`,
        description: `Select the ${WORKFLO_NAME.singular}`,
        value: campaignLogsFilters.campaign.displayValue as string,
        icon: (
          <CampaignsIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: (
          <SelectCampaignFilter onClose={handleGoBack} isCampaignLogs={true} />
        ),
        clearFilter: () => {
          dispatch(clearCampaignLogsCampaign());
        },
        showClearButton: campaignLogsFilters.campaign.value !== "",
      },
      {
        label: FILTER_LABELS.campaignLogs.selectUser.label,
        description: FILTER_LABELS.campaignLogs.selectUser.description,
        value: campaignLogsFilters.user.displayValue as string,
        icon: (
          <UserIcon className="w-[16px] h-[16px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: (
          <CampaignUserFilter
            onClose={handleGoBack}
            campaignTemplates={false}
            campaignLogs={true}
          />
        ),
        clearFilter: () => {
          dispatch(clearCampaignTemplatesUser());
        },
        showClearButton: campaignLogsFilters.user.value !== "",
      },
    ],
    "campaign-execution-logs": [
      {
        label: FILTER_LABELS.campaignExecutionLogs.modeOfCommunication.label,
        description:
          FILTER_LABELS.campaignExecutionLogs.modeOfCommunication.description,
        value: communicationMode?.displayValue as string,
        icon: (
          <InboxIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: (
          <CommunicationModeFilter
            onClose={handleDrawerClose}
            modalities={modalities}
            executionLogs={true}
          />
        ),
        clearFilter: () => {
          dispatch(clearCampaignExecutionLogsMode());
        },
        showClearButton: communicationMode.value !== "all",
      },
      {
        label: FILTER_LABELS.campaignExecutionLogs.dateRange.label,
        description: FILTER_LABELS.campaignExecutionLogs.dateRange.description,
        value:
          campaignExecutionLogsFilters.dateRange.value.from &&
          campaignExecutionLogsFilters.dateRange.value.to
            ? format(
                new Date(campaignExecutionLogsFilters.dateRange.value.from),
                "dd/MM/yyyy"
              ) +
              " - " +
              format(
                new Date(campaignExecutionLogsFilters.dateRange.value.to),
                "dd/MM/yyyy"
              )
            : "",
        icon: (
          <CalendarIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: (
          <CampaignCreatedOnFilter
            onClose={handleDrawerClose}
            executionLogs={true}
          />
        ),
        clearFilter: () => {
          dispatch(clearCampaignExecutionLogsDateRange());
        },
        showClearButton:
          campaignExecutionLogsFilters.dateRange.value.from !== "" ||
          campaignExecutionLogsFilters.dateRange.value.to !== "",
      },
      {
        label: FILTER_LABELS.campaignExecutionLogs.status.label,
        description: FILTER_LABELS.campaignExecutionLogs.status.description,
        value: campaignExecutionLogsFilters?.status?.displayValue as string,
        icon: (
          <StatusIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: <ExecutionLogsStatusFilter onClose={handleGoBack} />,
        clearFilter: () => {
          dispatch(clearCampaignExecutionLogsStatus());
        },
        showClearButton: campaignExecutionLogsFilters.status.value !== "",
      },
    ],
    analytics: [
      {
        label: FILTER_LABELS.analytics.duration.label,
        description: FILTER_LABELS.analytics.duration.description,
        value: duration?.displayValue as string,
        icon: (
          <CalendarIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: <AnalyticsDurationFilter onClose={handleGoBack} />,
        clearFilter: () => {
          dispatch(clearAnalyticsDuration());
        },
        showClearButton: duration.value !== defaultDurationValue,
      },
      {
        label: FILTER_LABELS.analytics.typeOfCommunication.label,
        description: FILTER_LABELS.analytics.typeOfCommunication.description,
        value: communicationType?.displayValue as string,
        icon:
          communicationType?.value === "all" ? (
            <CommunicationAllIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
          ) : communicationType?.value === "outbound" ? (
            <OutboundIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
          ) : (
            <InboundIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
          ),
        filterComponent: (
          <AnalyticsCommunicationTypeFilter onClose={handleGoBack} />
        ),
        showClearButton: communicationType?.value !== "inbound",
        clearFilter: () => {
          dispatch(clearAnalyticsCommunicationType());
        },
      },
      {
        label: FILTER_LABELS.analytics.modality.label,
        description: FILTER_LABELS.analytics.modality.description,
        value: analyticsModality?.displayValue as string,
        icon: (
          <InboxIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: (
          <CommunicationModeFilter
            onClose={handleGoBack}
            modalities={modalities}
            isAnalyticsBoard
          />
        ),
        showClearButton: analyticsModality?.value !== "all",
        clearFilter: () => {
          dispatch(clearAnalyticsModality());
        },
      },
    ],
    billing: [
      {
        label: FILTER_LABELS.billing.duration.label,
        description: FILTER_LABELS.billing.duration.description,
        value: duration?.displayValue as string,
        icon: (
          <CalendarIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: <BillingDurationFilter onClose={handleGoBack} />,
        clearFilter: () => {
          dispatch(clearBillingDuration());
        },
        showClearButton: duration.value !== defaultDurationValue,
      },
      {
        label: FILTER_LABELS.billing.typeOfCommunication.label,
        description: FILTER_LABELS.billing.typeOfCommunication.description,
        value: communicationType?.displayValue as string,
        icon:
          communicationType?.value === "all" ? (
            <CommunicationAllIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
          ) : communicationType?.value === "outbound" ? (
            <OutboundIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
          ) : (
            <InboundIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
          ),
        filterComponent: (
          <BillingCommunicationTypeFilter onClose={handleGoBack} />
        ),
        showClearButton: communicationType?.value !== "inbound",
        clearFilter: () => {
          dispatch(clearBillingCommunicationType());
        },
      },
    ],
    crm: [
      {
        label: FILTER_LABELS.crm.duration.label,
        description: FILTER_LABELS.crm.duration.description,
        value: duration?.displayValue as string,
        icon: (
          <CalendarIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: (
          <DurationFilter onClose={handleGoBack} crmLeads={true} />
        ),
        clearFilter: () => {
          dispatch(clearCrmLeadsDuration());
        },
        showClearButton: duration.value !== defaultDurationValue,
      },
      {
        label: FILTER_LABELS.crm.lastActivity.label,
        description: FILTER_LABELS.crm.lastActivity.description,
        value: lastActivity?.displayValue as string,
        icon: (
          <CalendarIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: <LastActivityFilter onClose={handleGoBack} />,
        clearFilter: () => {
          dispatch(clearCrmLeadsLastActivity());
        },
        showClearButton: !!lastActivity?.value,
      },
      ...(isVerbafloClient
        ? [
            {
              label: FILTER_LABELS.crm.bedCount.label,
              description: FILTER_LABELS.crm.bedCount.description,
              value: bedCount?.displayValue as string,
              icon: (
                <RoomTypeIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
              ),
              filterComponent: <BedCountFilter onClose={handleGoBack} />,
              showClearButton: bedCount?.value !== "",
              clearFilter: () => {
                dispatch(clearCrmLeadsBedCount());
              },
            },
            {
              label: FILTER_LABELS.crm.propertyCount.label,
              description: FILTER_LABELS.crm.propertyCount.description,
              value: propertyCount?.displayValue as string,
              icon: (
                <HomeIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
              ),
              filterComponent: <PropertyCountFilter onClose={handleGoBack} />,
              showClearButton: propertyCount?.value !== "",
              clearFilter: () => {
                dispatch(clearCrmLeadsPropertyCount());
              },
            },
            {
              label: FILTER_LABELS.crm.leadsNotUpdated30Days.label,
              description: FILTER_LABELS.crm.leadsNotUpdated30Days.description,
              value: leadsNotUpdated30Days,
              icon: (
                <CalendarIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
              ),
              showToggleSwitch: true,
              handleToggle: () => {
                dispatch(setCrmLeadsNotUpdated30Days(!leadsNotUpdated30Days));
                trackFilterApplied(
                  FILTER_LABELS.crm.leadsNotUpdated30Days.label,
                  !leadsNotUpdated30Days ? "enabled" : "disabled"
                );
              },
            },
          ]
        : []),
      {
        label: FILTER_LABELS.crm.typeOfCommunication.label,
        description: FILTER_LABELS.crm.typeOfCommunication.description,
        value: communicationType?.displayValue as string,
        icon:
          communicationType?.value === "all" ? (
            <CommunicationAllIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
          ) : communicationType?.value === "outbound" ? (
            <OutboundIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
          ) : (
            <InboundIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
          ),
        filterComponent: <CommunicationTypeFilter onClose={handleGoBack} />,
        showClearButton: communicationType?.value !== "all",
        clearFilter: () => {
          dispatch(clearCrmLeadsCommunicationType());
        },
      },
      {
        label: FILTER_LABELS.crm.sourceCountry.label,
        description: FILTER_LABELS.crm.sourceCountry.description,
        value:
          sourceCountry?.displayValue
            ?.slice(0, 1)
            ?.toString()
            ?.split(",")
            ?.join(", ") +
          (sourceCountry?.displayValue?.length > 1
            ? ", + " + (sourceCountry?.displayValue?.length - 1)
            : ""),
        trackingValue: (sourceCountry?.displayValue as string[])?.join(", "),
        icon: (
          <NetworkIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: (
          <CountryFilter
            onClose={handleGoBack}
            isCrmSourceCountry={true}
            isMultiSelect={true}
          />
        ),
        showClearButton: sourceCountry.value.length > 0,
        clearFilter: () => {
          dispatch(clearCrmLeadsSourceCountry());
        },
      },
      {
        label: FILTER_LABELS.crm.destinationCountry.label,
        description: FILTER_LABELS.crm.destinationCountry.description,
        value:
          destinationCountry?.displayValue
            ?.slice(0, 1)
            ?.toString()
            ?.split(",")
            ?.join(", ") +
          (destinationCountry?.displayValue?.length > 1
            ? ", + " + (destinationCountry?.displayValue?.length - 1)
            : ""),
        trackingValue: (destinationCountry?.displayValue as string[])?.join(
          ", "
        ),
        icon: (
          <LocationIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: (
          <CountryFilter
            onClose={handleGoBack}
            isDestinationCountry={true}
            isMultiSelect={true}
            isCrmDestinationCountry={true}
          />
        ),
        showClearButton: destinationCountry.value.length > 0,
        clearFilter: () => {
          dispatch(clearCrmLeadsDestinationCountry());
          dispatch(clearCrmLeadsDestinationCity());
          dispatch(clearCrmLeadsUniversity());
        },
      },
      {
        label: FILTER_LABELS.crm.destinationCity.label,
        description: FILTER_LABELS.crm.destinationCity.description,
        value:
          destinationCity?.displayValue
            ?.slice(0, 1)
            ?.toString()
            ?.split(",")
            ?.join(", ") +
          (destinationCity?.displayValue?.length > 1
            ? ", + " + (destinationCity?.displayValue?.length - 1)
            : ""),
        trackingValue: (destinationCity?.displayValue as string[])?.join(", "),
        icon: (
          <LocationIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: (
          <CityFilter
            onClose={handleGoBack}
            isMultiSelect={true}
            isCrmDestinationCity={true}
          />
        ),
        showClearButton: destinationCity.value.length > 0,
        clearFilter: () => {
          dispatch(clearCrmLeadsDestinationCity());
          dispatch(clearCrmLeadsUniversity());
        },
      },
      {
        label: FILTER_LABELS.crm.university.label,
        description: FILTER_LABELS.crm.university.description,
        value: university?.displayValue as string,
        icon: (
          <UniversityIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: <UniversityFilter onClose={handleGoBack} />,
        showClearButton: university.value !== "",
        clearFilter: () => {
          dispatch(clearCrmLeadsUniversity());
        },
      },
      {
        label: FILTER_LABELS.crm.assignedAgents.label,
        description: FILTER_LABELS.crm.assignedAgents.description,
        value:
          assignedAgents?.displayValue
            ?.slice(0, 2)
            ?.toString()
            ?.split(",")
            ?.join(", ") +
          (assignedAgents?.displayValue?.length > 2
            ? ", + " + (assignedAgents?.displayValue?.length - 2)
            : ""),
        trackingValue: assignedAgents?.displayValue?.join(", "),
        icon: (
          <ProfileTwoUser className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: <AgentFilter onClose={handleGoBack} />,
        showClearButton: assignedAgents?.value.length > 0,
        clearFilter: () => {
          dispatch(clearCrmLeadsAssignedAgents());
        },
      },
      {
        label: FILTER_LABELS.crm.tags.label,
        description: FILTER_LABELS.crm.tags.description,
        value: tags?.displayValue?.join(", "),
        icon: (
          <TagsIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: <TagsFilter onClose={handleGoBack} />,
        showClearButton: tags?.value.length > 0,
        clearFilter: () => {
          dispatch(clearCrmLeadsTags());
        },
      },
      {
        label: FILTER_LABELS.crm.roomType.label,
        description: FILTER_LABELS.crm.roomType.description,
        value:
          roomType?.displayValue
            ?.slice(0, 2)
            ?.toString()
            ?.split(",")
            ?.join(", ") +
          (roomType?.displayValue?.length > 2
            ? ", + " + (roomType?.displayValue?.length - 2)
            : ""),
        trackingValue: roomType?.displayValue?.join(", "),
        icon: (
          <RoomTypeIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: <RoomTypeFilter onClose={handleGoBack} />,
        showClearButton: roomType?.value.length > 0,
        clearFilter: () => {
          dispatch(clearCrmLeadsRoomType());
        },
      },
      {
        label: FILTER_LABELS.crm.leadStage.label,
        description: FILTER_LABELS.crm.leadStage.description,
        value:
          leadStage?.displayValue
            ?.slice(0, 2)
            ?.toString()
            ?.split(",")
            ?.join(", ") +
          (leadStage?.displayValue?.length > 2
            ? ", + " + (leadStage?.displayValue?.length - 2)
            : ""),
        trackingValue: leadStage?.displayValue?.join(", "),
        icon: (
          <LeadStageIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: <LeadStageFilter onClose={handleGoBack} />,
        showClearButton: leadStage?.value?.length > 0,
        clearFilter: () => {
          dispatch(clearCrmLeadsLeadStage());
        },
      },
      {
        label: FILTER_LABELS.crm.academicYear.label,
        description: FILTER_LABELS.crm.academicYear.description,
        value:
          academicYear?.displayValue
            ?.slice(0, 2)
            ?.toString()
            ?.split(",")
            ?.join(", ") +
          (academicYear?.displayValue?.length > 2
            ? ", + " + (academicYear?.displayValue?.length - 2)
            : ""),
        trackingValue: academicYear?.displayValue?.join(", "),
        icon: (
          <UniversityIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: <AcademicYearFilter onClose={handleGoBack} />,
        showClearButton: academicYear?.value.length > 0,
        clearFilter: () => {
          dispatch(clearCrmLeadsAcademicYear());
        },
      },
      {
        label: FILTER_LABELS.crm.dealStage.label,
        description: FILTER_LABELS.crm.dealStage.description,
        value:
          dealStage?.displayValue
            ?.slice(0, 2)
            ?.toString()
            ?.split(",")
            ?.join(", ") +
          (dealStage?.displayValue?.length > 2
            ? ", + " + (dealStage?.displayValue?.length - 2)
            : ""),
        trackingValue: dealStage?.displayValue?.join(", "),
        icon: (
          <LeadStageIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: (
          <DealMultiSelectFilter fieldKey="deal_stage" onClose={handleGoBack} />
        ),
        showClearButton: dealStage?.value.length > 0,
        clearFilter: () => {
          dispatch(clearCrmLeadsDealStage());
        },
      },
      {
        label: FILTER_LABELS.crm.dealProperty.label,
        description: FILTER_LABELS.crm.dealProperty.description,
        value:
          dealPropertyName?.displayValue
            ?.slice(0, 2)
            ?.toString()
            ?.split(",")
            ?.join(", ") +
          (dealPropertyName?.displayValue?.length > 2
            ? ", + " + (dealPropertyName?.displayValue?.length - 2)
            : ""),
        trackingValue: dealPropertyName?.displayValue?.join(", "),
        icon: (
          <HomeIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: (
          <DealMultiSelectFilter
            fieldKey="deal_property_name"
            onClose={handleGoBack}
          />
        ),
        showClearButton: dealPropertyName?.value.length > 0,
        clearFilter: () => {
          dispatch(clearCrmLeadsDealPropertyName());
        },
      },
      {
        label: FILTER_LABELS.crm.dealRoomType.label,
        description: FILTER_LABELS.crm.dealRoomType.description,
        value:
          dealRoomType?.displayValue
            ?.slice(0, 2)
            ?.toString()
            ?.split(",")
            ?.join(", ") +
          (dealRoomType?.displayValue?.length > 2
            ? ", + " + (dealRoomType?.displayValue?.length - 2)
            : ""),
        trackingValue: dealRoomType?.displayValue?.join(", "),
        icon: (
          <RoomTypeIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: (
          <DealMultiSelectFilter
            fieldKey="deal_room_type"
            onClose={handleGoBack}
          />
        ),
        showClearButton: dealRoomType?.value.length > 0,
        clearFilter: () => {
          dispatch(clearCrmLeadsDealRoomType());
        },
      },
      {
        label: FILTER_LABELS.crm.dealRoomNumber.label,
        description: FILTER_LABELS.crm.dealRoomNumber.description,
        value: dealRoomNumber?.displayValue as string,
        icon: (
          <RoomTypeIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: <DealRoomNumberFilter onClose={handleGoBack} />,
        showClearButton: Boolean(dealRoomNumber?.value),
        clearFilter: () => {
          dispatch(clearCrmLeadsDealRoomNumber());
        },
      },
      {
        label: FILTER_LABELS.crm.dealAcademicYear.label,
        description: FILTER_LABELS.crm.dealAcademicYear.description,
        value:
          dealAcademicYear?.displayValue
            ?.slice(0, 2)
            ?.toString()
            ?.split(",")
            ?.join(", ") +
          (dealAcademicYear?.displayValue?.length > 2
            ? ", + " + (dealAcademicYear?.displayValue?.length - 2)
            : ""),
        trackingValue: dealAcademicYear?.displayValue?.join(", "),
        icon: (
          <UniversityIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: (
          <DealMultiSelectFilter
            fieldKey="deal_academic_year"
            onClose={handleGoBack}
          />
        ),
        showClearButton: dealAcademicYear?.value.length > 0,
        clearFilter: () => {
          dispatch(clearCrmLeadsDealAcademicYear());
        },
      },
      {
        label: FILTER_LABELS.crm.dealAvailabilityTitle.label,
        description: FILTER_LABELS.crm.dealAvailabilityTitle.description,
        value:
          dealAvailabilityTitle?.displayValue
            ?.slice(0, 2)
            ?.toString()
            ?.split(",")
            ?.join(", ") +
          (dealAvailabilityTitle?.displayValue?.length > 2
            ? ", + " + (dealAvailabilityTitle?.displayValue?.length - 2)
            : ""),
        trackingValue: dealAvailabilityTitle?.displayValue?.join(", "),
        icon: (
          <HomeIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: (
          <DealMultiSelectFilter
            fieldKey="deal_availability_title"
            onClose={handleGoBack}
          />
        ),
        showClearButton: dealAvailabilityTitle?.value.length > 0,
        clearFilter: () => {
          dispatch(clearCrmLeadsDealAvailabilityTitle());
        },
      },
      {
        label: FILTER_LABELS.crm.dealCity.label,
        description: FILTER_LABELS.crm.dealCity.description,
        value:
          dealCity?.displayValue
            ?.slice(0, 2)
            ?.toString()
            ?.split(",")
            ?.join(", ") +
          (dealCity?.displayValue?.length > 2
            ? ", + " + (dealCity?.displayValue?.length - 2)
            : ""),
        trackingValue: dealCity?.displayValue?.join(", "),
        icon: (
          <LocationIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: (
          <DealMultiSelectFilter fieldKey="deal_city" onClose={handleGoBack} />
        ),
        showClearButton: dealCity?.value.length > 0,
        clearFilter: () => {
          dispatch(clearCrmLeadsDealCity());
        },
      },
      {
        label: FILTER_LABELS.crm.dealAssignee.label,
        description: FILTER_LABELS.crm.dealAssignee.description,
        value:
          dealAssignee?.displayValue
            ?.slice(0, 2)
            ?.toString()
            ?.split(",")
            ?.join(", ") +
          (dealAssignee?.displayValue?.length > 2
            ? ", + " + (dealAssignee?.displayValue?.length - 2)
            : ""),
        trackingValue: dealAssignee?.displayValue?.join(", "),
        icon: (
          <ProfileTwoUser className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: (
          <DealMultiSelectFilter
            fieldKey="deal_assignee"
            onClose={handleGoBack}
          />
        ),
        showClearButton: dealAssignee?.value.length > 0,
        clearFilter: () => {
          dispatch(clearCrmLeadsDealAssignee());
        },
      },
      {
        label: FILTER_LABELS.crm.property.label,
        description: FILTER_LABELS.crm.property.description,
        value:
          property?.displayValue
            ?.slice(0, 1)
            ?.toString()
            ?.split(",")
            ?.join(", ") +
          (property?.displayValue?.length > 1
            ? ", + " + (property?.displayValue?.length - 1)
            : ""),
        icon: (
          <HomeIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: (
          <PropertyFilter onClose={handleGoBack} isCrmLead={true} />
        ),
        showClearButton: property?.value?.length > 0,
        clearFilter: () => {
          dispatch(clearCrmLeadsProperty());
        },
      },
      {
        label: FILTER_LABELS.crm.utmSources.label,
        description: FILTER_LABELS.crm.utmSources.description,
        value:
          crmUtmSources?.displayValue
            ?.slice(0, 1)
            ?.toString()
            ?.split(",")
            ?.join(", ") +
          (crmUtmSources?.displayValue?.length > 1
            ? ", + " + (crmUtmSources?.displayValue?.length - 1)
            : ""),
        trackingValue: crmUtmSources?.displayValue?.join(", "),
        icon: (
          <NetworkIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: <UtmSourcesFilter onClose={handleGoBack} isCrm={true} />,
        showClearButton: crmUtmSources?.value?.length > 0,
        clearFilter: () => {
          dispatch(clearCrmLeadsUtmSources());
        },
      },
      {
        label: FILTER_LABELS.crm.utmMedium.label,
        description: FILTER_LABELS.crm.utmMedium.description,
        value:
          crmUtmMedium?.displayValue
            ?.slice(0, 1)
            ?.toString()
            ?.split(",")
            ?.join(", ") +
          (crmUtmMedium?.displayValue?.length > 1
            ? ", + " + (crmUtmMedium?.displayValue?.length - 1)
            : ""),
        trackingValue: crmUtmMedium?.displayValue?.join(", "),
        icon: (
          <TowerIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: <UtmMediumFilter onClose={handleGoBack} isCrm={true} />,
        showClearButton: crmUtmMedium?.value?.length > 0,
        clearFilter: () => {
          dispatch(clearCrmLeadsUtmMedium());
        },
      },
      {
        label: FILTER_LABELS.crm.attributionChannel.label,
        description: FILTER_LABELS.crm.attributionChannel.description,
        value:
          crmAttributionChannel?.displayValue
            ?.slice(0, 1)
            ?.toString()
            ?.split(",")
            ?.join(", ") +
          (crmAttributionChannel?.displayValue?.length > 1
            ? ", + " + (crmAttributionChannel?.displayValue?.length - 1)
            : ""),
        trackingValue: crmAttributionChannel?.displayValue?.join(", "),
        icon: (
          <GlobeOneIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: (
          <AttributionFilter
            field="attribution_channel"
            onClose={handleGoBack}
            isCrm={true}
          />
        ),
        showClearButton: crmAttributionChannel?.value?.length > 0,
        clearFilter: () => {
          dispatch(clearCrmLeadsAttributionChannel());
        },
      },
      {
        label: FILTER_LABELS.crm.standardMedium.label,
        description: FILTER_LABELS.crm.standardMedium.description,
        value:
          crmStandardMedium?.displayValue
            ?.slice(0, 1)
            ?.toString()
            ?.split(",")
            ?.join(", ") +
          (crmStandardMedium?.displayValue?.length > 1
            ? ", + " + (crmStandardMedium?.displayValue?.length - 1)
            : ""),
        trackingValue: crmStandardMedium?.displayValue?.join(", "),
        icon: (
          <UtmMediumIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: (
          <AttributionFilter
            field="standard_medium"
            onClose={handleGoBack}
            isCrm={true}
          />
        ),
        showClearButton: crmStandardMedium?.value?.length > 0,
        clearFilter: () => {
          dispatch(clearCrmLeadsStandardMedium());
        },
      },
      {
        label: FILTER_LABELS.crm.standardSource.label,
        description: FILTER_LABELS.crm.standardSource.description,
        value:
          crmStandardSource?.displayValue
            ?.slice(0, 1)
            ?.toString()
            ?.split(",")
            ?.join(", ") +
          (crmStandardSource?.displayValue?.length > 1
            ? ", + " + (crmStandardSource?.displayValue?.length - 1)
            : ""),
        trackingValue: crmStandardSource?.displayValue?.join(", "),
        icon: (
          <NetworkIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: (
          <AttributionFilter
            field="standard_source"
            onClose={handleGoBack}
            isCrm={true}
          />
        ),
        showClearButton: crmStandardSource?.value?.length > 0,
        clearFilter: () => {
          dispatch(clearCrmLeadsStandardSource());
        },
      },
      {
        label: FILTER_LABELS.crm.deviceType.label,
        description: FILTER_LABELS.crm.deviceType.description,
        value:
          crmDeviceType?.displayValue
            ?.slice(0, 1)
            ?.toString()
            ?.split(",")
            ?.join(", ") +
          (crmDeviceType?.displayValue?.length > 1
            ? ", + " + (crmDeviceType?.displayValue?.length - 1)
            : ""),
        trackingValue: crmDeviceType?.displayValue?.join(", "),
        icon: (
          <DeviceTypeIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: (
          <AttributionFilter
            field="device_type"
            onClose={handleGoBack}
            isCrm={true}
          />
        ),
        showClearButton: crmDeviceType?.value?.length > 0,
        clearFilter: () => {
          dispatch(clearCrmLeadsDeviceType());
        },
      },
      {
        label: FILTER_LABELS.crm.leadType.label,
        description: FILTER_LABELS.crm.leadType.description,
        value: leadType?.displayValue as string,
        icon: (
          <ProfileTwoUser className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: <LeadTypeFilter onClose={handleGoBack} />,
        showClearButton: leadType?.value !== "",
        clearFilter: () => {
          dispatch(clearCrmLeadsLeadType());
        },
      },
      {
        label: viewingLabels.plural,
        description: FILTER_LABELS.crm.viewings.description,
        value: viewing,
        icon: (
          <ViewingsIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        showToggleSwitch: true,
        handleToggle: () => {
          dispatch(setCrmLeadsViewing(!viewing));
          trackFilterApplied(
            viewingLabels.plural,
            !viewing ? "enabled" : "disabled"
          );
        },
      },
      {
        label: FILTER_LABELS.crm.excludeRepeatLeads.label,
        description: FILTER_LABELS.crm.excludeRepeatLeads.description,
        value: repeatLead,
        icon: (
          <RepeatLeadIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        showToggleSwitch: true,
        handleToggle: () => {
          dispatch(setCrmLeadsRepeatLead(!repeatLead));
          trackFilterApplied(
            FILTER_LABELS.crm.excludeRepeatLeads.label,
            !repeatLead ? "enabled" : "disabled"
          );
        },
      },
      // {
      //   label: FILTER_LABELS.crm.activeFollowUps.label,
      //   description: FILTER_LABELS.crm.activeFollowUps.description,
      //   value: activeFollowUps,
      //   icon: (
      //     <FlaggedIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
      //   ),
      //   showToggleSwitch: true,
      //   handleToggle: () => {
      //     dispatch(setCrmLeadsActiveFollowUps(!activeFollowUps));
      //     trackFilterApplied(
      //       FILTER_LABELS.crm.activeFollowUps.label,
      //       !activeFollowUps ? "enabled" : "disabled"
      //     );
      //   },
      // },
    ],
    playground: [
      {
        label: FILTER_LABELS.playground.duration.label,
        description: FILTER_LABELS.playground.duration.description,
        value: duration?.displayValue as string,
        icon: (
          <CalendarIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: (
          <DurationFilter onClose={handleGoBack} playground={true} />
        ),
        clearFilter: () => {
          dispatch(clearPlaygroundDuration());
        },
        showClearButton: duration.value !== defaultDurationValue,
      },
    ],
    "playground-logs": [
      {
        label: FILTER_LABELS.playgroundLogs.changesMadeOn.label,
        description: FILTER_LABELS.playgroundLogs.changesMadeOn.description,
        value: (playgroundChangesMadeOn?.displayValue as string) || "All",
        icon: (
          <SyncIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: <PlaygroundEnvFilter onClose={handleGoBack} />,
        clearFilter: () => {
          dispatch(clearPlaygroundChangesMadeOn());
        },
        showClearButton: playgroundChangesMadeOn?.value !== "all",
      },
      {
        //Created on Date filter
        label: FILTER_LABELS.playgroundLogs.createdOnDate.label,
        description: FILTER_LABELS.playgroundLogs.createdOnDate.description,
        value:
          playgroundCreatedOn?.value?.from && playgroundCreatedOn?.value?.to
            ? `${getDateTimeByFormat(new Date(playgroundCreatedOn?.value?.from))?.date} - ${getDateTimeByFormat(new Date(playgroundCreatedOn?.value?.to))?.date}`
            : "",
        icon: (
          <CalendarIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: <LogsCreatedOnFilter onClose={handleGoBack} />,
        clearFilter: () => {
          dispatch(clearPlaygroundLogsCreatedOn());
        },
        showClearButton:
          playgroundCreatedOn?.value?.from !== "" ||
          playgroundCreatedOn?.value?.to !== "",
      },
    ],
    "communication-analytics": [
      {
        label: FILTER_LABELS.communicationAnalytics.modeOfCommunication.label,
        description:
          FILTER_LABELS.communicationAnalytics.modeOfCommunication.description,
        value: communicationMode?.displayValue as string,
        icon: (
          <InboxIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: (
          <CommunicationModeFilter
            onClose={handleGoBack}
            communicationAnalytics={true}
            modalities={modalities}
          />
        ),
        clearFilter: () => {
          dispatch(clearCommunicationAnalyticsMode());
        },
        showClearButton: communicationMode.value !== "widget",
      },
      {
        label: FILTER_LABELS.communicationAnalytics.duration.label,
        description: FILTER_LABELS.communicationAnalytics.duration.description,
        value: duration?.displayValue as string,
        icon: (
          <CalendarIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: (
          <DurationFilter
            onClose={handleGoBack}
            communicationAnalytics={true}
          />
        ),
        clearFilter: () => {
          dispatch(clearCommunicationAnalyticsDuration());
        },
        showClearButton: duration.value !== defaultDurationValue,
      },
    ],
    "pms-properties": [
      {
        label: "Country",
        description: "Select the destination country",
        value: pmsPropertiesFilters?.destinationCountry?.displayValue as string,
        icon: (
          <LocationIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: (
          <CountryFilter onClose={handleGoBack} isPmsDestCountry={true} />
        ),
        showClearButton: pmsPropertiesFilters?.destinationCountry?.id !== null,
        clearFilter: () => {
          dispatch(clearPmsDestinationCountry());
          dispatch(clearPmsCity());
          dispatch(clearPmsUniversity());
        },
      },
      {
        label: "City",
        description: "Select the city",
        value: pmsPropertiesFilters?.city?.displayValue as string,
        icon: (
          <LocationIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: <CityFilter onClose={handleGoBack} isPms={true} />,
        showClearButton: pmsPropertiesFilters?.city?.id !== null,
        clearFilter: () => {
          dispatch(clearPmsCity());
          dispatch(clearPmsUniversity());
        },
        disabled: pmsPropertiesFilters?.destinationCountry?.id === null,
      },
      {
        label: "University",
        description: "Select the university",
        value: pmsPropertiesFilters?.university?.displayValue as string,
        icon: (
          <UniversityIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: (
          <UniversityFilter onClose={handleGoBack} isPms={true} />
        ),
        showClearButton: pmsPropertiesFilters?.university?.id !== null,
        clearFilter: () => {
          dispatch(clearPmsUniversity());
        },
        disabled: pmsPropertiesFilters?.city?.id === null,
      },
      {
        label: dynamicFilterLabels.communication.budget.label,
        description: "Select the budget per week",
        value:
          pmsPropertiesFilters?.budget?.displayValue
            ?.slice(0, 1)
            ?.toString()
            ?.split(",")
            ?.join(", ") +
          (pmsPropertiesFilters?.budget?.displayValue?.length > 1
            ? ", + " + (pmsPropertiesFilters?.budget?.displayValue?.length - 1)
            : ""),
        trackingValue: pmsPropertiesFilters?.budget?.displayValue?.join(", "),
        icon: dynamicFilterLabels.communication.budget.icon,
        filterComponent: (
          <BudgetFilter
            onClose={handleGoBack}
            isPms={true}
            isMultiSelect={false}
          />
        ),
        showClearButton: pmsPropertiesFilters?.budget?.value?.length > 0,
        clearFilter: () => {
          dispatch(clearPmsBudget());
        },
      },
      {
        label: "Room Type",
        description: "Select the room type",
        value:
          pmsPropertiesFilters?.roomType?.displayValue
            ?.slice(0, 2)
            ?.toString()
            ?.split(",")
            ?.join(", ") +
          (pmsPropertiesFilters?.roomType?.displayValue?.length > 2
            ? ", + " +
              (pmsPropertiesFilters?.roomType?.displayValue?.length - 2)
            : ""),
        trackingValue: pmsPropertiesFilters?.roomType?.displayValue?.join(", "),
        icon: (
          <RoomTypeIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: (
          <RoomTypeFilter
            onClose={handleGoBack}
            isPms={true}
            isMultiSelect={false}
          />
        ),
        showClearButton: pmsPropertiesFilters?.roomType?.value.length > 0,
        clearFilter: () => {
          dispatch(clearPmsRoomType());
        },
      },
    ],
    "pms-logs": [
      {
        label: "Duration",
        description: "Select the duration",
        value: pmsLogsFilters?.duration?.displayValue as string,
        icon: (
          <CalendarIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: (
          <DurationFilter onClose={handleGoBack} isPmsLogs={true} />
        ),
        clearFilter: () => {
          dispatch(clearPmsLogsDuration());
        },
        showClearButton: pmsLogsFilters?.duration?.value !== defaultDurationValue,
      },
    ],
    tasks: [
      {
        label: FILTER_LABELS.tasks(isVerbafloClient).dueToday.label,
        description: FILTER_LABELS.tasks(isVerbafloClient).dueToday.description,
        value: tasksFilters.dueToday,
        icon: (
          <FlaggedIcon className="w-[18px] h-[18px] text-verba-red-alert dark:text-verba-red-alert-dk" />
        ),
        showToggleSwitch: true,
        handleToggle: () => {
          dispatch(setTasksDueToday(!tasksFilters.dueToday));
          trackFilterApplied(
            FILTER_LABELS.tasks(isVerbafloClient).dueToday.label,
            !tasksFilters.dueToday ? "enabled" : "disabled"
          );
        },
      },
      {
        label: FILTER_LABELS.tasks(isVerbafloClient).overdue.label,
        description: FILTER_LABELS.tasks(isVerbafloClient).overdue.description,
        value: tasksFilters.overdue,
        icon: (
          <FlaggedIcon className="w-[18px] h-[18px] text-verba-red-alert dark:text-verba-red-alert-dk" />
        ),
        showToggleSwitch: true,
        handleToggle: () => {
          dispatch(setTasksOverdue(!tasksFilters.overdue));
          trackFilterApplied(
            FILTER_LABELS.tasks(isVerbafloClient).overdue.label,
            !tasksFilters.overdue ? "enabled" : "disabled"
          );
        },
      },
      {
        label: FILTER_LABELS.tasks(isVerbafloClient).upcoming.label,
        description: FILTER_LABELS.tasks(isVerbafloClient).upcoming.description,
        value: tasksFilters.upcoming,
        icon: (
          <TasksIcon className="w-[18px] h-[18px] text-verba-blue dark:text-verba-blue-dk" />
        ),
        showToggleSwitch: true,
        handleToggle: () => {
          dispatch(setTasksUpcoming(!tasksFilters.upcoming));
          trackFilterApplied(
            FILTER_LABELS.tasks(isVerbafloClient).upcoming.label,
            !tasksFilters.upcoming ? "enabled" : "disabled"
          );
        },
      },
      {
        label: FILTER_LABELS.tasks(isVerbafloClient).completed.label,
        description: FILTER_LABELS.tasks(isVerbafloClient).completed.description,
        value: tasksFilters.completed,
        icon: (
          <TasksIcon className="w-[18px] h-[18px] text-verba-green-success dark:text-verba-green-success-dk" />
        ),
        showToggleSwitch: true,
        handleToggle: () => {
          dispatch(setTasksCompleted(!tasksFilters.completed));
          trackFilterApplied(
            FILTER_LABELS.tasks(isVerbafloClient).completed.label,
            !tasksFilters.completed ? "enabled" : "disabled"
          );
        },
      },
      {
        label: FILTER_LABELS.tasks(isVerbafloClient).assignees.label,
        description:
          FILTER_LABELS.tasks(isVerbafloClient).assignees.description,
        value: truncateItemsWithCount(
          (tasksFilters.assigneeIds.displayValue as string[]).join(", ")
        ),
        icon: (
          <ProfileTwoUser className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: <TaskAssigneeFilter onClose={handleGoBack} />,
        clearFilter: () => {
          dispatch(clearTasksAssigneeIds());
        },
        showClearButton: tasksFilters.assigneeIds.value.length > 0,
      },
      {
        label: "Property",
        description: "Filter by property",
        value: truncateItemsWithCount(
          (tasksFilters.propertyIds.displayValue as string[]).join(", ")
        ),
        icon: (
          <HomeIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: (
          <PropertyFilter onClose={handleGoBack} isTasks={true} />
        ),
        clearFilter: () => {
          dispatch(clearTasksPropertyIds());
        },
        showClearButton: tasksFilters.propertyIds.value.length > 0,
      },
      {
        label: "Destination Country",
        description: "Filter by destination country",
        value: truncateItemsWithCount(
          (tasksFilters.countryIds.displayValue as string[]).join(", ")
        ),
        icon: (
          <LocationIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: (
          <CountryFilter
            onClose={handleGoBack}
            isTasks={true}
            isMultiSelect={true}
          />
        ),
        clearFilter: () => {
          dispatch(clearTasksCountryIds());
          dispatch(clearTasksCityIds());
        },
        showClearButton: tasksFilters.countryIds.value.length > 0,
      },
      {
        label: "Destination City",
        description: tasksFilters.countryIds.value.length > 0
          ? "Filter by destination city"
          : "Select a country first",
        value: truncateItemsWithCount(
          (tasksFilters.cityIds.displayValue as string[]).join(", ")
        ),
        disabled: tasksFilters.countryIds.value.length === 0,
        icon: (
          <LocationIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: (
          <CityFilter
            onClose={handleGoBack}
            isTasks={true}
            isMultiSelect={true}
          />
        ),
        clearFilter: () => {
          dispatch(clearTasksCityIds());
        },
        showClearButton: tasksFilters.cityIds.value.length > 0,
      },
    ],
    "crm-inbox": [
      {
        label: "Duration",
        description: "Filter by time period",
        value: crmInboxFilters.duration?.displayValue as string,
        icon: (
          <CalendarIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: (
          <DurationFilter onClose={handleGoBack} isCrmInbox={true} />
        ),
        clearFilter: () => {
          dispatch(clearCrmInboxDuration());
        },
        showClearButton: crmInboxFilters.duration?.value !== defaultDurationValue,
      },
      {
        label: "Assigned Agents",
        description: "Select the assigned agents",
        value: truncateItemsWithCount(
          (crmInboxFilters.assignedAgents.displayValue as string[]).join(", ")
        ),
        icon: (
          <ProfileTwoUser className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: (
          <AgentFilter onClose={handleGoBack} isCrmInbox={true} />
        ),
        clearFilter: () => {
          dispatch(clearCrmInboxAssignedAgents());
        },
        showClearButton: crmInboxFilters.assignedAgents.value.length > 0,
      },
    ],
    viewings: [
      {
        label: FILTER_LABELS.viewings.scheduledOnDate.label,
        description: FILTER_LABELS.viewings.scheduledOnDate.description,
        value:
          viewingsFilters?.scheduledOn?.displayValue?.from &&
          viewingsFilters?.scheduledOn?.displayValue?.to
            ? format(
                new Date(viewingsFilters.scheduledOn.displayValue.from),
                "dd/MM/yyyy"
              ) +
              " - " +
              format(
                new Date(viewingsFilters.scheduledOn.displayValue.to),
                "dd/MM/yyyy"
              )
            : "",
        icon: (
          <CalendarIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: (
          <ViewingsDateRangeFilter
            onClose={handleGoBack}
            filterKey="scheduledOn"
          />
        ),
        clearFilter: () => {
          dispatch(clearViewingsScheduledOn());
        },
        showClearButton:
          viewingsFilters?.scheduledOn?.value?.from !== "" ||
          viewingsFilters?.scheduledOn?.value?.to !== "",
      },
      {
        label: FILTER_LABELS.viewings.createdOnDate.label,
        description: FILTER_LABELS.viewings.createdOnDate.description,
        value:
          viewingsFilters?.createdOn?.displayValue?.from &&
          viewingsFilters?.createdOn?.displayValue?.to
            ? format(
                new Date(viewingsFilters.createdOn.displayValue.from),
                "dd/MM/yyyy"
              ) +
              " - " +
              format(
                new Date(viewingsFilters.createdOn.displayValue.to),
                "dd/MM/yyyy"
              )
            : "",
        icon: (
          <CalendarIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: (
          <ViewingsDateRangeFilter
            onClose={handleGoBack}
            filterKey="createdOn"
          />
        ),
        clearFilter: () => {
          dispatch(clearViewingsCreatedOn());
        },
        showClearButton:
          viewingsFilters?.createdOn?.value?.from !== "" ||
          viewingsFilters?.createdOn?.value?.to !== "",
      },
      {
        label: FILTER_LABELS.viewings.property.label,
        description: FILTER_LABELS.viewings.property.description,
        value:
          viewingsFilters?.property?.displayValue
            ?.slice(0, 1)
            ?.toString()
            ?.split(",")
            ?.join(", ") +
          (viewingsFilters?.property?.displayValue?.length > 1
            ? ", + " + (viewingsFilters?.property?.displayValue?.length - 1)
            : ""),
        icon: (
          <HomeIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: (
          <PropertyFilter onClose={handleGoBack} isViewings={true} />
        ),
        clearFilter: () => {
          dispatch(clearViewingsProperty());
        },
        showClearButton: viewingsFilters?.property?.value?.length > 0,
      },
      {
        label: FILTER_LABELS.viewings.attendeeResponse.label,
        description: FILTER_LABELS.viewings.attendeeResponse.description,
        value:
          (viewingsFilters?.attendeeResponse?.displayValue
            ?.slice(0, 1)
            ?.join(", ") ?? "") +
          (viewingsFilters?.attendeeResponse?.displayValue?.length > 1
            ? ", + " +
              (viewingsFilters.attendeeResponse.displayValue.length - 1)
            : ""),
        icon: (
          <InboxIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
        ),
        filterComponent: (
          <ViewingsAttendeeResponseFilter onClose={handleGoBack} />
        ),
        clearFilter: () => {
          dispatch(clearViewingsAttendeeResponse());
        },
        showClearButton:
          (viewingsFilters?.attendeeResponse?.value?.length ?? 0) > 0,
      },
    ],
  };

  useEffect(() => {
    if (prevActiveFilterRef.current && !activeFilter) {
      const prevFilter = prevActiveFilterRef.current;
      const currentFilters =
        filterMappings[filterType as keyof typeof filterMappings];
      const updatedFilter = currentFilters?.find(
        (f) => f.label === prevFilter.label
      );
      if (updatedFilter && updatedFilter.value !== prevFilter.value) {
        if (updatedFilter.showClearButton === false) {
          trackFilterCleared(prevFilter.label);
        } else {
          trackFilterApplied(
            prevFilter.label,
            updatedFilter.trackingValue || (updatedFilter.value as string) || ""
          );
        }
      }
    }
    prevActiveFilterRef.current = activeFilter;
  });

  const handleClearAllFilters = () => {
    if (filterType === "campaigns") {
      dispatch(clearAllCampaignsFilters());
      dispatch(setCurrentPage(1));
    } else if (filterType === "campaign-communications") {
      dispatch(clearAllCampaignCommunicationsFilters());
    } else if (filterType === "campaign-templates") {
      dispatch(clearAllCampaignTemplatesFilters());
    } else if (filterType === "campaign-logs") {
      dispatch(clearAllCampaignLogsFilters());
    } else if (filterType === "campaign-execution-logs") {
      dispatch(clearAllCampaignExecutionLogsFilters());
    } else if (filterType === "tasks") {
      dispatch(clearAllTasksFilters());
    } else if (filterType === "crm") {
      dispatch(clearAllCrmLeadsFilters());
    } else if (filterType === "analytics") {
      dispatch(clearAllAnalyticsFilters());
    } else if (filterType === "billing") {
      dispatch(clearAllBillingFilters());
    } else if (filterType === "playground-logs") {
      dispatch(clearAllPlaygroundLogsFilters());
    } else if (filterType === "communication-analytics") {
      dispatch(clearAllCommunicationAnalyticsFilters());
    } else if (filterType === "pms-properties") {
      dispatch(clearAllPmsPropertiesFilters());
    } else if (filterType === "pms-logs") {
      dispatch(clearAllPmsLogsFilters());
    } else if (filterType === "crm-inbox") {
      dispatch(clearAllCrmInboxFilters());
    } else if (filterType === "viewings") {
      dispatch(clearViewingsFilters());
    } else {
      dispatch(clearAllCommunicationsFilters());
    }
    trackAllFiltersCleared();
    handleDrawerClose();
  };

  const enableClearAllPmsPropertiesFiltersLocal = useSelector(
    enableClearAllPmsPropertiesFiltersSelector
  );

  const enableClearAllPmsLogsFiltersLocal = useSelector(
    enableClearAllPmsLogsFiltersSelector
  );

  const enableClearAllFilters = useSelector(
    filterType === "campaigns"
      ? enableClearAllCampaignsFilters
      : filterType === "campaign-communications"
        ? enableClearAllCampaignCommunicationsFilters
        : filterType === "campaign-templates"
          ? enableClearAllCampaignTemplatesFilters
          : filterType === "campaign-logs"
            ? enableClearAllCampaignLogsFilters
            : filterType === "campaign-execution-logs"
              ? enableClearAllCampaignExecutionLogsFilters
              : filterType === "tasks"
                ? (state: RootState) =>
                    enableClearAllTasksFilters({
                      tasksFilter: state.tasksFilter,
                    })
                : filterType === "crm"
                  ? enableClearAllCrmLeadsFilters
                  : filterType === "analytics"
                    ? enableClearAllAnalyticsFilters
                    : filterType === "billing"
                      ? enableClearAllBillingFilters
                      : filterType === "playground-logs"
                        ? enableClearAllPlaygroundLogsFilters
                        : filterType === "communication-analytics"
                          ? enableClearAllCommunicationAnalyticsFilters
                          : filterType === "pms-properties"
                            ? () => enableClearAllPmsPropertiesFiltersLocal
                            : filterType === "pms-logs"
                              ? () => enableClearAllPmsLogsFiltersLocal
                              : filterType === "crm-inbox"
                                ? enableClearAllCrmInboxFilters
                                : filterType === "viewings"
                                  ? enableClearAllViewingsFilters
                                  : enableClearAllCommunicationsFilters
  );
  return (
    <div>
      <Drawer
        open={openDrawer}
        onClose={handleDrawerClose}
        direction="right"
        size={size}
        overlayColor="rgba(0,0,0,0.7)"
        duration={300}
        closeOnOverlayClick={true}
        closeOnEscape={true}
        drawerContainerClassName="rounded-l-[8px]"
      >
        {activeFilter ? (
          <FilterDetailView
            filter={activeFilter}
            onBack={handleGoBack}
            onClose={() => {
              handleGoBack();
              handleDrawerClose();
            }}
          />
        ) : (
          <div className="flex flex-col h-full">
            <div className="flex flex-col gap-4 px-3 py-3 border-b border-border-gray dark:border-border-gray-dk">
              <div className="flex items-center justify-between">
                <h2 className="text-verba-indigo dark:text-verba-indigo-dk text-base font-semibold">
                  Filters
                </h2>
                <div className="flex items-center gap-4.5">
                  {enableClearAllFilters && (
                    <Button
                      innerText="Clear All"
                      onClick={handleClearAllFilters}
                      buttonContainerClass="py-1 px-3 text-verba-indigo dark:text-verba-indigo-dk hover:text-fixed-white dark:hover:text-fixed-white-dk border border-border-gray dark:border-border-gray-dk rounded-sm hover:bg-verba-red-alert dark:hover:bg-verba-red-alert-dk transition-colors hover:border-verba-red-alert dark:hover:border-verba-red-alert-dk"
                      innerTextClass="text-md font-medium whitespace-nowrap"
                    />
                  )}

                  <button
                    className={`w-[16px] h-[16px] bg-tag-gray dark:bg-tag-gray-dk rounded-full flex flex-col items-center justify-center transition-transform duration-200 hover:scale-110`}
                    aria-label="Close modal"
                    onClick={handleDrawerClose}
                  >
                    <CloseIcon className="w-[6px] h-[6px] text-verba-indigo dark:text-verba-indigo-dk" />
                  </button>
                </div>
              </div>
            </div>
            <div className="flex-1 overflow-y-auto">
              <div className="flex flex-col">
                {(() => {
                  const currentFilters =
                    filterMappings[filterType as keyof typeof filterMappings] ||
                    [];

                  const renderFilterItem = (
                    filter: (typeof currentFilters)[number],
                    itemClassName = ""
                  ) => (
                    <FilterItem
                      key={filter.label}
                      label={filter.label}
                      description={filter.description}
                      disabled={filter.disabled}
                      value={filter.value || ""}
                      icon={filter.icon || null}
                      onClick={() => {
                        setActiveFilter(filter as FilterItem);
                      }}
                      showClearButton={filter.showClearButton}
                      clearFilter={() => {
                        filter.clearFilter?.();
                        trackFilterCleared(filter.label);
                      }}
                      handleToggle={filter.handleToggle}
                      showToggleSwitch={filter?.showToggleSwitch}
                      itemClassName={itemClassName}
                    />
                  );

                  if (filterType !== "crm") {
                    return currentFilters.map((filter) =>
                      renderFilterItem(filter)
                    );
                  }

                  const isBookingFilter = (
                    filter: (typeof currentFilters)[number]
                  ) => {
                    const componentType = (
                      filter as {
                        filterComponent?: { type?: unknown };
                      }
                    )?.filterComponent?.type;
                    return (
                      componentType === DealMultiSelectFilter ||
                      componentType === DealRoomNumberFilter
                    );
                  };

                  const leadFilters = currentFilters.filter(
                    (filter) => !isBookingFilter(filter)
                  );
                  const bookingFilters = currentFilters.filter(isBookingFilter);

                  return (
                    <>
                      <SectionDivider label="Leads" />
                      {leadFilters.map((filter, index) =>
                        renderFilterItem(
                          filter,
                          index === 0
                            ? "border-t border-border-gray dark:border-border-gray-dk"
                            : ""
                        )
                      )}
                      {bookingFilters.length > 0 && (
                        <SectionDivider label="Booking" />
                      )}
                      {bookingFilters.map((filter, index) =>
                        renderFilterItem(
                          filter,
                          index === 0
                            ? "border-t border-border-gray dark:border-border-gray-dk"
                            : ""
                        )
                      )}
                    </>
                  );
                })()}
              </div>
            </div>
          </div>
        )}
      </Drawer>
    </div>
  );
};

export default Filters;
